var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular.module('QMC.Home', ['QMC.Aufgaben', 'QMC.Fachleistung', 'ui.router']);
})();
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        let HomeController = class HomeController {
            /**
             * QMC.Home.HomeController
             * @constructor
             * @param $timeout
             * @param $qui
             * @param fachleistungService
             * @param $scope
             * @param terminService
             * @param lng
             */
            constructor($location, $timeout, $qui, fachleistungService, $scope, terminService, userService, lng, permissionService, $state) {
                this.$location = $location;
                this.$timeout = $timeout;
                this.$qui = $qui;
                this.fachleistungService = fachleistungService;
                this.$scope = $scope;
                this.terminService = terminService;
                this.userService = userService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.$state = $state;
                this.canModifyReportText = false;
                this.showPlaned = false;
                this.showRaw = false;
                this.plannedDocusForMeCount = 0;
                this.birthdayWidget = false;
                this.awayWidget = false;
                this.appointmentWidget = true;
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    this.events();
                    $(".help-block").parent("div").attr("style", "");
                });
                userService.getUserSettings(["LANDINGPAGE", "GLOBAL.LANDINGPAGE", "FLS.CASE.DAYSTOHIGHLIGHT", "FLS.CONTINGENT.DONTSHOWINDRECT", "LANDINGPAGE.LOGO", "BIRTHDAY.WIDGET.ACTIVE", "AWAY.WIDGET.ACTIVE", "APPOINTMENT.WIDGET.ACTIVE", "FLS.PLANEDRAWDAYS", "FLS.PLANEDDAYSFUTURE"], true).then((data) => {
                    this.$qui.waitForEl('#navLogo', () => {
                        let landingpage = '';
                        if (data[1].value !== (undefined || null) && data[1].value !== "") {
                            landingpage = data[1].value;
                        }
                        if (data[0].value !== (undefined || null) && data[0].value !== "") {
                            landingpage = data[0].value;
                        }
                        if (landingpage.length > 0 && landingpage !== 'dashboard') {
                            if (data[4].value.toLowerCase() === 'true') {
                                $('#navLogo').attr('href', '#' + landingpage);
                                QMC.Common.personalLocalStorage.setItem('logo', '#' + landingpage);
                            }
                            else {
                                QMC.Common.personalLocalStorage.removeItem('logo');
                                $('#navLogo').attr('href', '#');
                            }
                            if (window.sessionStorage.getItem("RecentlyLoggedIn") !== "true") {
                                const path = window.location.href.substring(0, window.location.href.indexOf('#'));
                                window.location.href = path + '#' + landingpage;
                                window.sessionStorage.setItem("RecentlyLoggedIn", "true");
                            }
                        }
                        else {
                            QMC.Common.personalLocalStorage.removeItem('logo');
                            $('#navLogo').attr('href', '#');
                        }
                        this.birthdayWidget = data[5].value.toLowerCase() === 'true';
                        this.awayWidget = data[6].value.toLowerCase() === 'true';
                        this.appointmentWidget = data[7].value.toLowerCase() === 'true' || data[7].value.length === 0;
                        this.userService.getGlobalSettings(['FLS.DONTSHOWRAWIFEMPTYDOCUSALLOWED', 'FLS.ALLOWEMPTYREPORTS']).then((globalData) => {
                            let days = parseInt(data[8].value);
                            if (isNaN(days) || days === null || days === undefined)
                                days = QMC.Common.UserSettingConstantsAndDefaults.PLANEDRAWDAYS;
                            let daysFuture = parseInt(data[9].value);
                            if (isNaN(daysFuture) || daysFuture === null || daysFuture === undefined)
                                daysFuture = QMC.Common.UserSettingConstantsAndDefaults.PLANEDDAYSFUTURE;
                            if (globalData[0].value.toLocaleLowerCase() === 'true')
                                this.showRaw = daysFuture >= 0 && globalData[1].value.toLocaleLowerCase() === 'true';
                            this.showPlaned = days >= 0;
                            this.showRaw = daysFuture >= 0;
                            if (this.showPlaned || this.showRaw)
                                this.GetPlanedAndRawDocumentations(days, daysFuture);
                        });
                    });
                    window.sessionStorage.setItem("RecentlyLoggedIn", "true");
                    //Get the permission to modify reporttext
                    this.permissionService.getPermissionsByObjectTypes([230020]).then((data) => {
                        this.canModifyReportText = data[0].modify; //is user allowed to change reporttext (in german: Berichtstexte )
                    });
                });
            }
            /////////////// DISPLAY LOGIC ///////////////
            GetMiniWidgetClasses() {
                // count active widgets
                let count = 0;
                if (this.canModifyReportText && this.showRaw) // raw docu
                    count++;
                if (this.showPlaned) // planed docu
                    count++;
                if (this.birthdayWidget) // birthdays
                    count++;
                if (this.awayWidget) // away
                    count++;
                const even = Math.floor(12 / count);
                return `col-md-${even} col-sm-${this.getSmMiniWidgetColSpan(even)}`;
            }
            getSmMiniWidgetColSpan(span) {
                span = span * 2;
                if (span < 12 && span > 6)
                    span = 6;
                return span;
            }
            /**
             * Sidebar Event
             * @description Toggle between table and card view
             */
            events() {
                if (window.innerWidth > 1299) {
                    this.affixAgent();
                }
            }
            /**
             * checkForDatetime
             * @description Check for the current daytime, like morning ...
             */
            checkForDatetime() {
                const date = new Date();
                const h = date.getHours();
                if ((h >= 0) && (h <= 10))
                    return this.lng.translate(20000040, 'Morgen <br>');
                if ((h > 10) && (h <= 17))
                    return this.lng.translate(20000041, 'Tag');
                else
                    return this.lng.translate(20000042, 'Abend');
            }
            /**
             * sayHello
             * @description Send a notification to the view
             */
            sayHello() {
                const dayTime = this.checkForDatetime();
                var greet = this.lng.translate(20000043, "Guten") + " " + dayTime;
                const note = {
                    title: $('#session').data().fullName,
                    message: greet,
                    icon: 'qm-icon-bell',
                    status: 'default',
                    timer: 3000,
                    delay: 1500
                };
                if (!$('body').hasClass('greeted')) {
                    $('body').addClass('greeted');
                    this.$qui.notify(note);
                }
            }
            /**
            * affixAgent
            * @description
            * @param null
            */
            affixAgent() {
                var width = $("#rightbar").width() - 1;
                $("#rightbar").css("right", 0);
                $("#rightbar").width(width);
                $('#rightbar').affix({
                    offset: {
                        top: 166
                    }
                });
                $('#rightbar')
                    .on('affix-top.bs.affix', function () {
                    $("#rightbar").css("right", 0);
                    $("#rightbar").width(width);
                }).on('affix.bs.affix', function () {
                    if ($("#rightbar .scroller").height() > (window.innerHeight - 166))
                        $("#rightbar .scroller").css("overflow-y", "auto").css("max-height", (window.innerHeight - 166));
                });
            }
            /**
             * currentFilter
             * @description Check if the current filter is enabled
             * @param entry
             */
            currentfilter(entry) {
                console.log(entry);
                const filterActive = $('#filterActive').val();
                if (filterActive === 'true')
                    return entry.isCurrent;
                else
                    return true;
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * GetPlanedDocumentations
             * @description Gets all planed but not docuemented documentations in the past x days.
             */
            GetPlanedAndRawDocumentations(days, daysFuture) {
                if (this.showPlaned)
                    this.fachleistungService.getPlannedDocumentations(days, daysFuture).then((data) => {
                        this.planedDocumentations = data;
                        this.plannedDocusForMeCount = data.filter(x => x.carerId === $('#session').data().personId).length;
                    });
                if (this.showRaw)
                    this.fachleistungService.getRawDocumentations(days).then((data) => {
                        this.rawDocumentations = data;
                    });
            }
            setStandardNavTemp() {
                this.userService.getNavigation(QMC.Common.Constants.DEFAULT_NAV_ID).then((data) => {
                    window.createNav(data);
                    //window.localStorage.setItem("NAVIGATION", Common.Constants.DEFAULT_NAV_ID);
                    setTimeout(() => {
                        $("#side-menu").metisMenu('dispose');
                        $('#side-menu').metisMenu();
                    }, 250);
                });
            }
        };
        HomeController = __decorate([
            QMC.Controller('QMC.Home', 'HomeController'),
            QMC.Inject('$location', '$timeout', '$qui', 'FachleistungService', '$scope', 'TerminService', 'UserService', 'QmcLanguageService', 'QmcPermissionService', '$state')
        ], HomeController);
        Home.HomeController = HomeController;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        let NavConfigurationController = class NavConfigurationController {
            /////////////////////////// Constructor //////////////////////////
            constructor($qui, $scope, $state, userService, lng, $timeout) {
                this.$qui = $qui;
                this.$scope = $scope;
                this.$state = $state;
                this.userService = userService;
                this.lng = lng;
                this.$timeout = $timeout;
                this.isSavingNav = false;
                this.newContainerName = "";
                this.qmIcons = [];
                this.selectedIcon = "";
                this.notSupported = false;
                this.selectedFileNames = [];
                this.uploads = [];
                this.importName = "";
                $qui.init("einstellungen", () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    this.events();
                });
                if (this.checkIe()) {
                    this.notSupported = true;
                    return;
                }
                let styleSheets = document.styleSheets;
                for (let i = 0; i < styleSheets.length; i++)
                    for (let j = 0; j < styleSheets[i].cssRules.length; j++)
                        if (styleSheets[i].cssRules[j].selectorText != (null || undefined) && styleSheets[i].cssRules[j].selectorText.startsWith(".qm-icon-")) {
                            var iconName = styleSheets[i].cssRules[j].selectorText;
                            this.qmIcons.push(iconName.substr(1, iconName.indexOf(":") - 1));
                        }
                this.init();
                this.loading = true;
                this.getAvailableNavs();
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            init() {
                this.userService.getUserSettings(["NAVIGATION.WEB"]).then((data) => {
                    this.selectedNavId = this.getSettingValue("NAVIGATION.WEB", QMC.Common.Constants.DEFAULT_NAV_ID, data).toLowerCase();
                    this.loadNav();
                    this.loading = false;
                });
                this.navColors = window.bodyColorClasses.split(' ');
                //remove login
                this.navColors.shift();
            }
            events() {
                this.$scope.$watch('vm.selectedNavId', () => { this.loadNav(); });
                this.$scope.$watch('vm.selectedFileNames', () => { this.stripSuffix(); }, true);
            }
            favToggle(id) {
                if (this.checkIfFav(id))
                    this.currentNav.subNav = this.removeFromNavigationRecursive(id, this.currentNav.subNav).list;
                else
                    this.currentNav.subNav.push(this.convertNavigationPageItemToNavigationItem(this.getNavItemById(id), this.getNavColorByTargetIdRecursive(id, this.currentNav.mainNav)));
                this.createPreview();
            }
            checkIfFav(id) {
                for (let i = 0; i < this.currentNav.subNav.length; i++)
                    if (this.currentNav.subNav[i].navigationItemId === id)
                        return true;
                return false;
            }
            toggleIcon(icon) {
                this.selectedIcon = icon;
            }
            createNewContainer() {
                $('#createContainerModal').modal('hide');
                let isSecondLevel = false;
                //Check if we got a secound level container
                if (this.newContainerParentId !== "configPreview") {
                    let found = false;
                    for (let i = 0; i < this.currentNav.mainNav.length; i++) {
                        if (this.currentNav.mainNav[i].navigationItemId === this.newContainerParentId) {
                            found = true;
                            break;
                        }
                    }
                    isSecondLevel = !found;
                }
                //createContainer Object
                let container = {
                    color: this.newContainerColor,
                    icon: this.selectedIcon,
                    link: "",
                    navigationItemId: QMC.Common.Constants.GUID_EMPTY,
                    subItems: [{
                            color: this.newContainerColor,
                            icon: "",
                            link: "placeholder",
                            navigationItemId: this.generateGuid(),
                            subItems: [],
                            title: "",
                            type: 0
                        }],
                    title: this.newContainerName,
                    type: isSecondLevel ? 2 : 1
                };
                this.addItemToNav(this.newContainerParentId, container);
                this.createPreview();
                this.$qui.scopeApply(this.$scope);
            }
            ////////////////////////////// DnD ///////////////////////////////
            initDnd() {
                if (this.currentNav.isFix)
                    return;
                let dndDropTargets = document.querySelectorAll('.drop-target');
                let dndDraggables = document.querySelectorAll('[draggable=true]');
                for (let i = 0; i < dndDropTargets.length; i++) {
                    if (!dndDropTargets[i].classList.contains("setupDT")) {
                        dndDropTargets[i].classList.add("setupDT");
                        dndDropTargets[i].addEventListener('dragenter', this.handleNavElementDragEnter, false);
                        dndDropTargets[i].addEventListener('dragleave', this.handleNavElementDragLeave, false);
                        dndDropTargets[i].addEventListener('dragover', this.handleNavElementDragOver, false);
                        dndDropTargets[i].addEventListener('drop', this.handleNavElementDrop.bind(this, this), false);
                    }
                }
                for (let i = 0; i < dndDraggables.length; i++) {
                    if (!dndDraggables[i].classList.contains("setupDR")) {
                        dndDraggables[i].classList.add("setupDR");
                        dndDraggables[i].addEventListener('dragstart', this.handleDragStart, false);
                        dndDraggables[i].addEventListener('dragend', this.handleNavElementDragEnd, false);
                    }
                }
            }
            handleDragStart(e) {
                console.log("drag start", e);
                e.target.style.opacity = '0.4'; // e.target is the source node.
                e.dataTransfer.setData('id', e.target.id);
                e.dataTransfer.setData('type', e.target.type);
                e.dataTransfer.effectAllowed = 'move';
                if (e.target.classList.contains("nav-element")) {
                    e.dataTransfer.setData("source", "candidate");
                    e.dataTransfer.setData("candidate", "");
                }
                if (e.target.classList.contains("nav-container-container")) {
                    e.dataTransfer.setData("source", "container");
                    e.dataTransfer.setData("container", "");
                }
                if (e.target.classList.contains("nav-config-item")) {
                    e.dataTransfer.setData("source", "navigation");
                    e.dataTransfer.setData("navigation", "");
                }
            }
            handleNavElementDragOver(e) {
                //console.log("drag over", e);
                if (e.preventDefault)
                    e.preventDefault(); // Necessary. Allows us to drop.
                return false;
            }
            handleNavElementDragEnter(e) {
                //console.log("drag enter", e);
                // if the target has no id its properly not our real target but a child of it. so we iterate its parents till we find one with an id
                let target = e.target;
                while (target.id == (null || undefined || "")) {
                    target = target.parentNode;
                }
                let isValidTarget = false;
                console.log("checking if target is valid for drop", target, e.dataTransfer.types);
                //if (e.dataTransfer.types.includes("navigation"))
                isValidTarget =
                    (e.dataTransfer.types.includes("navigation") && (target.id === "configPreview" || target.id === "navElementContainer" || target.id === "navContainerContainer" || target.classList.contains("nav-container-container") || target.classList.contains("nav-config-item") || target.classList.contains("nav-element"))) ||
                        (e.dataTransfer.types.includes("candidate") && (target.id === "configPreview" || target.id === "navElementContainer" || target.classList.contains("nav-config-item") || target.classList.contains("nav-element"))) ||
                        (e.dataTransfer.types.includes("container") && (target.id === "configPreview" || target.classList.contains("nav-config-item")));
                e.preventDefault();
                if (target.classList.contains("drop-target") && isValidTarget) {
                    target.style.borderBottom = "thick solid orange";
                    e.dataTransfer.dropEffect = "move";
                }
                else {
                    e.dataTransfer.dropEffect = "none";
                }
            }
            handleNavElementDragLeave(e) {
                //console.log("drag leave", e);
                e.preventDefault();
                e.target.style.borderBottom = "unset";
            }
            handleNavElementDragEnd(e) {
                //console.log("drag end", e);
                e.preventDefault();
                let dndDropTargets = document.querySelectorAll('.drop-target');
                for (let i = 0; i < dndDropTargets.length; i++) {
                    dndDropTargets[i].style.borderBottom = "unset";
                    e.target.style.opacity = "unset";
                }
            }
            handleNavElementDrop(_scope, e) {
                e.preventDefault();
                e.stopPropagation();
                let dropId = e.dataTransfer.getData('id');
                let dropType = e.dataTransfer.getData('type');
                let dropSource = e.dataTransfer.getData('source');
                // if the target has no id its properly not our real target but a child of it. so we iterate its parents till we find one with an id
                let target = e.target;
                while (target.id == (null || undefined || "")) {
                    target = target.parentNode;
                }
                console.log("drop data ID:", dropId, "TYPE:", dropType, "SOURCE:", dropSource, "DROP TARGET:", e.target, "PROPOSED TARGET", target);
                //move from navigation to candidate list
                if (dropType == 0 && dropSource == "navigation" && (target.id === "navElementContainer" || target.parentNode.id === "navElementContainer")) {
                    console.log("dropped nav item into candidate list");
                    // remove item form navigation and add it to candidate list
                    this.removeFromNavigation(dropId);
                    //than push element to candidate array
                    this.addItemToCandidates(dropId);
                }
                //move from navigation to container list
                if ((dropType == 1 || dropType == 2) && dropSource == "navigation" && (target.classList.contains("nav-container-container") || target.id == "navContainerContainer")) {
                    console.log("dropped container from nav to container list");
                    //readd items to candidate list
                    this.addSubItemsToCandidates(this.getItemFromNavRecursive(dropId, this.currentNav.mainNav).subItems);
                    // remove container and its childs form navigation
                    this.removeFromNavigation(dropId);
                }
                //move from candidate list to nav
                if (dropType == 0 && dropSource == "candidate" && (target.id === "configPreview" || target.classList.contains("nav-config-item"))) {
                    console.log("dropped item from candidate to nav", target.tagName.toLowerCase());
                    //if we're dropping to the container put the item first, else place it after the target
                    this.addItemToNav(target.id, this.convertNavigationPageItemToNavigationItem(this.getNavItemById(dropId), "login"));
                    //remove item from candidate list
                    this.removeItemFromCandidate(dropId);
                }
                //move item or container inside the nav
                if (dropSource == "navigation" && target.classList.contains("nav-config-item") && (dropId != target.id) && !this.checkIfIdChildInNav(dropId, target.id)) {
                    console.log("dropped item from nav to the nav (hopefully in another place, otherwise this would be completely pointless)");
                    this.addItemToNav(target.id, this.removeFromNavigation(dropId));
                    // if something was a subcontainer before, it now becomes type 1
                    this.fixContainerTypes(this.currentNav.mainNav, false);
                }
                //add new container
                if (dropSource == "container" && (target.id === "configPreview" || target.classList.contains("nav-config-item"))) {
                    this.newContainerParentId = target.id;
                    this.newContainerColor = dropId;
                    this.newContainerName = "";
                    this.selectedIcon = "";
                    $('#createContainerModal').modal('show');
                }
                // fix favs
                let itemsToToggle = [];
                for (let i = 0; i < this.currentNav.subNav.length; i++) {
                    //let favItem = this.currentNav.subNav[i];
                    let navItem = this.getItemFromNavRecursive(this.currentNav.subNav[i].navigationItemId, this.currentNav.mainNav);
                    this.currentNav.subNav[i].type = 3;
                    if (navItem == (null || undefined))
                        itemsToToggle.push(this.currentNav.subNav[i].navigationItemId);
                    //this.favToggle(favItem.navigationItemId);
                    else
                        this.currentNav.subNav[i].color = navItem.color;
                }
                for (let i = 0; i < itemsToToggle.length; i++)
                    this.favToggle(itemsToToggle[i]);
                this.createPreview();
                this.$qui.scopeApply(this.$scope);
            }
            ///////////////////////// DnD Helpers ////////////////////////////
            addItemToNav(targetId, itemToAdd) {
                if (targetId === "configPreview")
                    this.currentNav.mainNav.unshift(itemToAdd);
                else
                    this.currentNav.mainNav = this.addItemToNavRecursive(targetId, this.currentNav.mainNav, itemToAdd);
            }
            addItemToNavRecursive(targetId, navArray, itemToAdd) {
                //find target in current nav
                for (let i = 0; i < navArray.length; i++) {
                    if (navArray[i].navigationItemId === targetId) {
                        let index = i;
                        if (navArray.length > i)
                            index++;
                        if (navArray[i].link === "placeholder")
                            navArray.splice(index - 1, 1, itemToAdd);
                        else
                            navArray.splice(index, 0, itemToAdd);
                        return navArray;
                    }
                    else if (navArray[i].subItems != (null || undefined)) {
                        var copiedItemToAdd = angular.copy(itemToAdd);
                        copiedItemToAdd.color = navArray[i].color;
                        navArray[i].subItems = this.addItemToNavRecursive(targetId, navArray[i].subItems, copiedItemToAdd);
                    }
                }
                return navArray;
            }
            getNavItemById(id) {
                for (let i = 0; i < this.navigationItems.length; i++)
                    if (this.navigationItems[i].id === id)
                        return this.navigationItems[i];
                return null;
            }
            convertNavigationPageItemToNavigationItem(item, color) {
                return {
                    color: color,
                    icon: item.icon,
                    link: item.link,
                    navigationItemId: item.id,
                    subItems: [],
                    title: this.lng.translate(item.languageTag, item.title),
                    type: 0
                };
            }
            getNavColorByTargetIdRecursive(id, array) {
                let result = null;
                for (let i = 0; i < array.length; i++) {
                    if (array[i].navigationItemId === id)
                        return array[i].color;
                    if (array[i].subItems != (null || undefined))
                        result = this.getNavColorByTargetIdRecursive(id, array[i].subItems);
                    if (result)
                        return result;
                }
                return result;
            }
            addSubItemsToCandidates(array) {
                for (let i = 0; i < array.length; i++)
                    if (array[i].subItems == (null || undefined) || array[i].subItems.length === 0)
                        this.addItemToCandidates(array[i].navigationItemId);
                    else
                        this.addSubItemsToCandidates(array[i].subItems);
            }
            addItemToCandidates(id) {
                let item;
                for (let i = 0; i < this.navigationItems.length; i++)
                    if (this.navigationItems[i].id == id) {
                        item = this.navigationItems[i];
                        break;
                    }
                if (item !== (null || undefined))
                    this.navigationCandidates.push(item);
                this.navigationCandidates.sort(function (a, b) {
                    let textA = a.title.toUpperCase();
                    let textB = b.title.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
                this.$qui.scopeApply(this.$scope);
            }
            removeFromNavigation(id) {
                let result = this.removeFromNavigationRecursive(id, this.currentNav.mainNav);
                this.currentNav.mainNav = result.list;
                return result.item;
            }
            removeFromNavigationRecursive(id, itemList) {
                let item;
                // try to find item by id
                for (let i = 0; i < itemList.length; i++) {
                    if (itemList[i].navigationItemId === id) {
                        item = itemList[i];
                        let list = itemList.filter(function (obj) {
                            return obj.navigationItemId !== id;
                        });
                        return { list, item };
                    }
                    else if (itemList[i].subItems != (null || undefined)) {
                        let recursiveResult = this.removeFromNavigationRecursive(id, itemList[i].subItems);
                        itemList[i].subItems = recursiveResult.list;
                        if (recursiveResult.item != (null || undefined))
                            return { list: itemList, item: recursiveResult.item };
                    }
                }
                return { list: itemList, item };
            }
            removeItemFromCandidate(id) {
                for (let i = 0; i < this.navigationCandidates.length; i++) {
                    if (this.navigationCandidates[i].id === id) {
                        let spliceReturn = this.navigationCandidates.splice(i, 1);
                    }
                }
            }
            //////////////////////// CREATE ELEMENTS /////////////////////////
            createPreview() {
                let previewUl = document.getElementById('configPreview');
                let favArea = document.getElementById('favoriteConfig');
                // wait till preview is ready
                if (previewUl !== null && previewUl !== undefined) {
                    // remove current preview
                    while (previewUl.firstChild) {
                        previewUl.removeChild(previewUl.firstChild);
                    }
                    while (favArea.firstChild) {
                        favArea.removeChild(favArea.firstChild);
                    }
                    this.createPreviewForSubItems(previewUl, this.currentNav.mainNav);
                    this.createSubNav(favArea, this.currentNav.subNav);
                    //add this to make sure the background box is big enough (dirty little cheat)
                    let placeholder = document.createElement("div");
                    placeholder.setAttribute("style", "display: table; width: 100%;");
                    favArea.appendChild(placeholder);
                    this.initDnd();
                    return;
                }
                setTimeout(() => { this.createPreview(); }, 100);
            }
            createPreviewForSubItems(parentUl, items, is2ndLvl = false) {
                for (let i = 0; i < items.length; i++) {
                    switch (items[i].type) {
                        case 1:
                            // first level container
                            this.create1stLvlNavContainer(parentUl, items[i]);
                            break;
                        case 2:
                            // second level container
                            this.create2ndLvlNavContainer(parentUl, items[i]);
                            break;
                        case 0:
                        default:
                            // link
                            this.createNavItem(parentUl, items[i], is2ndLvl);
                            break;
                    }
                }
            }
            createNavItem(parentUl, item, is2ndLvl = false) {
                let li = document.createElement("li");
                let spanFav = document.createElement("span");
                let imageFav = document.createElement("i");
                if (item.link !== "placeholder")
                    if (this.checkIfFav(item.navigationItemId))
                        imageFav.setAttribute("class", "fa fa-star qm-nav-config-fav-button");
                    else
                        imageFav.setAttribute("class", "fa fa-star-o qm-nav-config-fav-button");
                if (!this.currentNav.isFix)
                    imageFav.onclick = function () { this.favToggle(item.navigationItemId); }.bind(this, this);
                spanFav.appendChild(imageFav);
                li.appendChild(spanFav);
                if (!is2ndLvl) {
                    let span = document.createElement("span");
                    let spanImage = document.createElement("span");
                    let image = document.createElement("i");
                    image.setAttribute("class", item.icon);
                    spanImage.appendChild(image);
                    li.appendChild(spanImage);
                    li.appendChild(span);
                    span.appendChild(document.createTextNode(item.title));
                }
                else {
                    li.appendChild(document.createTextNode(item.title));
                }
                li.setAttribute("draggable", "true");
                li.setAttribute("class", "nav-config-item drop-target");
                li.setAttribute("id", item.navigationItemId);
                li.setAttribute("type", "0");
                parentUl.appendChild(li);
                // remove item from element list
                this.navigationCandidates = this.navigationCandidates.filter(function (obj) {
                    return obj.id !== item.navigationItemId;
                });
            }
            create1stLvlNavContainer(parent, item) {
                let li = document.createElement("li");
                li.setAttribute("class", "nav-config-item drop-target qm-nav-config-colored-" + item.color);
                let containerId = this.generateGuid();
                li.setAttribute("id", containerId);
                item.navigationItemId = containerId;
                let imageSpan = document.createElement("span");
                let image = document.createElement("i");
                image.setAttribute("class", item.icon);
                let span = document.createElement("span");
                span.appendChild(document.createTextNode(item.title));
                imageSpan.appendChild(image);
                li.appendChild(imageSpan);
                li.appendChild(span);
                let ul = document.createElement("ul");
                ul.setAttribute("class", "nav-config-item qm-nav-config-colored-ul-" + item.color);
                li.setAttribute("type", "1");
                li.appendChild(ul);
                parent.appendChild(li);
                li.setAttribute("draggable", "true");
                this.createPreviewForSubItems(ul, item.subItems);
            }
            create2ndLvlNavContainer(parent, item) {
                let li = document.createElement("li");
                let containerId = this.generateGuid();
                li.setAttribute("id", containerId);
                item.navigationItemId = containerId;
                let spanImage = document.createElement("span");
                spanImage.setAttribute("style", "margin-left: 36px;");
                let image = document.createElement("i");
                image.setAttribute("class", item.icon);
                let span = document.createElement("span");
                span.appendChild(document.createTextNode(item.title));
                let arrow = document.createElement("span");
                arrow.setAttribute("class", "fa arrow pull-right");
                spanImage.appendChild(image);
                li.appendChild(spanImage);
                li.appendChild(span);
                li.appendChild(arrow);
                let ul = document.createElement("ul");
                li.setAttribute("type", "2");
                li.appendChild(ul);
                parent.appendChild(li);
                li.setAttribute("draggable", "true");
                li.setAttribute("class", "nav-config-item drop-target");
                ul.setAttribute("draggable", "true");
                ul.setAttribute("class", "nav-config-item drop-target");
                this.createPreviewForSubItems(ul, item.subItems, true);
            }
            createSubNav(parent, items) {
                for (let i = 0; i < items.length; i++) {
                    let item = items[i];
                    let itemContainer = document.createElement("div");
                    itemContainer.setAttribute("class", "nav-item-" + i);
                    itemContainer.setAttribute("id", "nav-item-" + i);
                    let div = document.createElement("div");
                    div.setAttribute("class", "desktop qm-nav-config-fav nav-fav-" + item.color);
                    let iconSpan = document.createElement("span");
                    iconSpan.setAttribute("class", "qm-tab " + item.icon);
                    div.appendChild(iconSpan);
                    let textSpan = document.createElement("span");
                    textSpan.appendChild(document.createTextNode(item.title));
                    div.appendChild(textSpan);
                    itemContainer.appendChild(div);
                    parent.appendChild(itemContainer);
                }
            }
            checkIfIdChildInNav(parentId, childId) {
                var parent = this.getItemFromNavRecursive(parentId, this.currentNav.mainNav);
                if (parent.subItems == (null || undefined))
                    return false;
                var child = this.getItemFromNavRecursive(childId, parent.subItems);
                return child != (null || undefined);
            }
            //////////////////////// SERVICEFUNCTION /////////////////////////
            getSettingValue(key, defaultValue, settings) {
                return $.grep(settings, function (e) { return e.key === key; })[0].value === "" ? defaultValue : $.grep(settings, function (e) { return e.key === key; })[0].value;
            }
            swap(inputArray, index_A, index_B) {
                let temp = inputArray[index_A];
                inputArray[index_A] = inputArray[index_B];
                inputArray[index_B] = temp;
                return inputArray;
            }
            generateGuid() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            }
            getItemFromNavRecursive(id, list) {
                let result;
                for (let i = 0; i < list.length; i++) {
                    if (list[i].navigationItemId == id) {
                        result = list[i];
                        break;
                    }
                    else if (list[i].subItems != (null || undefined) && result == (null || undefined))
                        result = this.getItemFromNavRecursive(id, list[i].subItems);
                }
                return result;
            }
            fixContainerTypes(list, isSub, color = "login") {
                for (let i = 0; i < list.length; i++) {
                    if (list[i].type == 1 && isSub)
                        list[i].type = 2;
                    if (list[i].type == 2 && !isSub)
                        list[i].type = 1;
                    if (list[i].type == 0)
                        list[i].color = color;
                    if (list[i].subItems != (null || undefined))
                        this.fixContainerTypes(list[i].subItems, true, list[i].color);
                }
            }
            ///////////////////////// Immport/Exprt //////////////////////////
            exportNav() {
                // get navi name
                let name = "navigation";
                for (let i = 0; i < this.navs.length; i++) {
                    if (this.navs[i].id === this.selectedNavId) {
                        name = this.navs[i].caption;
                        break;
                    }
                }
                let element = document.createElement('a');
                element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify({
                    mainNav: this.currentNav.mainNav,
                    subNav: this.currentNav.subNav
                })));
                element.setAttribute('download', name + ".webnav");
                element.style.display = 'none';
                document.body.appendChild(element);
                element.click();
                document.body.removeChild(element);
            }
            openImportModal() {
                $('#importNavModal').modal('show');
                this.openFileSelector();
            }
            openFileSelector() {
                this.selectedFileNames = [];
                this.uploads = [];
                const fileSelector = angular.element('#fileselect');
                fileSelector.click();
                if (this.checkIe())
                    for (var file in fileSelector[0].files)
                        this.selectedFileNames.push(fileSelector[0].files[file].name);
            }
            stripSuffix() {
                if (this.selectedFileNames.length === 0 || this.selectedFileNames[0].indexOf(".webnav") < 1)
                    return;
                this.importName = this.selectedFileNames[0].substring(0, this.selectedFileNames[0].indexOf(".webnav"));
            }
            checkIe() {
                var ua = window.navigator.userAgent;
                var msie = ua.indexOf('MSIE ');
                if (msie > 0) {
                    // IE 10 or older => return version number
                    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
                }
                var trident = ua.indexOf('Trident/');
                if (trident > 0) {
                    // IE 11 => return version number
                    var rv = ua.indexOf('rv:');
                    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
                }
                var edge = ua.indexOf('Edge/');
                if (edge > 0) {
                    // Edge (IE 12+) => return version number
                    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
                }
                // other browser
                return false;
            }
            setFile() {
                if (this.uploads.length === 0)
                    return;
                this.loading = true;
                $('#importNavModal').modal('hide');
                // file input creates automatically a base64 including mimetype, we only need the base64 part
                // we don't use basic atob for it has problems with utf
                let base64 = this.b64DecodeUnicode(this.uploads[0].substring(this.uploads[0].indexOf("base64") + 7, this.uploads[0].length));
                let imported = JSON.parse(base64);
                this.userService.postNewNavigation({ caption: this.importName, mainNav: imported.mainNav, subNav: imported.subNav }).then((data) => {
                    this.getAvailableNavs();
                    this.selectedNavId = data.createdObjectId;
                    this.loadNav();
                }).finally(() => {
                    this.loading = false;
                });
            }
            b64DecodeUnicode(str) {
                // Going backwards: from bytestream, to percent-encoding, to original string.
                return decodeURIComponent(atob(str).split('').map(function (c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));
            }
            ////////////////////////// SERVICECALLS //////////////////////////
            loadNav() {
                this.loadingNav = true;
                if (this.currentNav != undefined)
                    this.currentNav.isFix = false;
                this.userService.getNavigationItems().then((data) => {
                    for (let i = 0; i < data.length; i++)
                        data[i].title = this.lng.translate(data[i].languageTag, data[i].title);
                    this.navigationItems = data;
                    this.navigationCandidates = angular.copy(data);
                    this.userService.getNavigation(this.selectedNavId).then((data) => {
                        if (data.mainNav == (null || undefined))
                            data.mainNav = [];
                        if (data.subNav == (null || undefined))
                            data.subNav = [];
                        this.currentNav = data;
                        this.loadingNav = false;
                        this.createPreview();
                    });
                });
            }
            getAvailableNavs() {
                this.userService.getAvailableNavigations().then((data) => {
                    this.navs = data;
                    for (let i = 0; i < this.navs.length; i++)
                        if (this.navs[i].isFix)
                            this.navs[i].groupName = this.lng.translate(20000226, "Fix");
                        else
                            this.navs[i].groupName = this.lng.translate(20000227, "Editierbar");
                    this.navsMap = this.navs.map(x => ({ text: x.caption, value: x.id, group: x.groupName }));
                });
            }
            createNewNav() {
                this.loading = true;
                this.userService.postNewNavigation({ caption: this.newNavName, mainNav: [], subNav: [] }).then((data) => {
                    $('#createNewNavModal').modal('hide');
                    this.getAvailableNavs();
                    this.selectedNavId = data.createdObjectId;
                    this.loadNav();
                }).finally(() => {
                    this.loading = false;
                });
            }
            copyNav() {
                this.loading = true;
                this.userService.postNewNavigation({ caption: this.newNavName, mainNav: this.currentNav.mainNav, subNav: this.currentNav.subNav }).then((data) => {
                    $('#copyNavModal').modal('hide');
                    this.getAvailableNavs();
                    this.selectedNavId = data.createdObjectId;
                    this.loadNav();
                }).finally(() => {
                    this.loading = false;
                });
            }
            saveNav() {
                if (this.currentNav.isFix) {
                    return;
                }
                //fix first level color
                for (let i = 0; i < this.currentNav.mainNav.length; i++)
                    if (this.currentNav.mainNav[i].type === 0)
                        this.currentNav.mainNav[i].color = "login";
                console.log("saving", this.selectedNavId, this.currentNav);
                this.isSavingNav = true;
                this.userService.putNavigation(this.selectedNavId, { mainNav: this.currentNav.mainNav, subNav: this.currentNav.subNav }).then((data) => {
                    console.log("updated", data);
                    this.$qui.notify(this.$qui.successNote);
                    this.isSavingNav = false;
                });
            }
            deleteNav() {
                this.loading = true;
                this.userService.deleteNavigation(this.selectedNavId).then((data) => {
                    console.log("deleted", data);
                    this.getAvailableNavs();
                    this.userService.getUserSettings(["NAVIGATION.WEB"]).then((data) => {
                        this.selectedNavId = this.getSettingValue("NAVIGATION.WEB", QMC.Common.Constants.DEFAULT_NAV_ID, data);
                        this.loadNav();
                        this.loading = false;
                    }).finally(() => {
                        this.loading = false;
                    });
                });
            }
            setNav() {
                let settings = {
                    settings: [{ key: "NAVIGATION.WEB", value: this.selectedNavId }]
                };
                if (!this.currentNav.isFix) {
                    this.saveNav();
                }
                this.loadingNav = true;
                this.userService.setUserSettings(settings).then((data) => {
                    this.reloadNav();
                });
            }
            reloadNav() {
                if (this.isSavingNav)
                    setTimeout(() => { this.reloadNav(); }, 250);
                else {
                    this.userService.getNavigation(this.selectedNavId).then((data) => {
                        this.loadingNav = false;
                        window.createNav(data);
                        window.localStorage.setItem("NAVIGATION", JSON.stringify(data));
                        setTimeout(() => {
                            $("#side-menu").metisMenu('dispose');
                            $('#side-menu').metisMenu();
                        }, 250);
                    });
                }
            }
        };
        NavConfigurationController = __decorate([
            QMC.Controller('QMC.Home', 'NavConfigurationController'),
            QMC.Inject('$qui', '$scope', '$state', 'UserService', 'QmcLanguageService', '$timeout')
        ], NavConfigurationController);
        Home.NavConfigurationController = NavConfigurationController;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        var UserService_1;
        let UserService = UserService_1 = class UserService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.setSettingsInFlight = new Map();
            }
            // Password
            putNewPassword(currentPassword, newPassword) {
                const data = {
                    id: null,
                    objectId: null,
                    NewPassword: newPassword,
                    CurrentPassword: currentPassword
                };
                return super.put('/User/Password?dbConnectionString=' + document.getElementById('session').getAttribute("data-db-connection"), data).then((data) => {
                    return data;
                });
            }
            getCheckPasswordRules(newPassword) {
                return super.post('/User/CheckPasswordRules?dbConnectionString=' + document.getElementById('session').getAttribute("data-db-connection"), { Password: newPassword }).then((data) => {
                    return data;
                });
            }
            // Application info
            getVersionInfo() {
                return super.get('/Info/build/version').then((info) => { return info; });
            }
            // Session & authentication
            deleteSession() {
                super.performLogout();
            }
            checkTokenRefresh() {
                if (this.isExternalTokenSupplyMode()) {
                    return;
                }
                const jwtToken = this.getAccessToken();
                if (jwtToken) {
                    const decodedToken = this.decodeJwt(jwtToken);
                    const oneMinuteInMilliseconds = 1 * 60 * 1000;
                    const oneMinBeforeExpirationInUtc = (decodedToken.exp * 1000) - oneMinuteInMilliseconds;
                    const nowInUtc = new Date().getTime();
                    if (oneMinBeforeExpirationInUtc < nowInUtc) {
                        super.renewToken();
                    }
                }
            }
            decodeJwt(token) {
                const base64Url = token.split('.')[1];
                const base64 = base64Url.replace('-', '+').replace('_', '/');
                return JSON.parse(atob(base64));
            }
            ;
            getUserUpdates() {
                return super.get('/session/UserUpdates').then((data) => {
                    return data;
                });
            }
            // User & global settings
            getSettingCacheKey(global, webvalue, settingKey) {
                return `settings:${global ? 'global' : 'user'}:${webvalue}:${settingKey}`;
            }
            getSettings(global, keys, webvalue = true) {
                if (keys.length === 0) {
                    return this.$q.resolve([]);
                }
                const cacheOptions = { ttlMs: UserService_1.SETTINGS_CACHE_TTL_MS };
                const cachedByKey = new Map();
                const missingKeys = [];
                for (const key of keys) {
                    const cached = this.peekCached(this.getSettingCacheKey(global, webvalue, key));
                    if (cached) {
                        cachedByKey.set(key, cached);
                    }
                    else {
                        missingKeys.push(key);
                    }
                }
                if (missingKeys.length === 0) {
                    return this.$q.resolve(this.collectSettingsInOrder(keys, cachedByKey));
                }
                return this.get('/Settings', { keys: missingKeys, webvalue: webvalue, global: global }).then((data) => {
                    const fetched = data;
                    for (const setting of fetched) {
                        this.setCached(this.getSettingCacheKey(global, webvalue, setting.key), setting, cacheOptions);
                        cachedByKey.set(setting.key, setting);
                    }
                    return this.collectSettingsInOrder(keys, cachedByKey);
                });
            }
            collectSettingsInOrder(keys, settingsByKey) {
                return keys
                    .map((key) => settingsByKey.get(key))
                    .filter((setting) => setting !== undefined);
            }
            updateSettingsCache(global, webValue, updatedSettings) {
                const cacheOptions = { ttlMs: UserService_1.SETTINGS_CACHE_TTL_MS };
                for (const setting of updatedSettings) {
                    this.setCached(this.getSettingCacheKey(global, webValue, setting.key), setting, cacheOptions);
                }
            }
            getSetSettingsRequestKey(global, webValue, data) {
                const settings = [...data.settings]
                    .sort((a, b) => a.key.localeCompare(b.key))
                    .map((setting) => ({ key: setting.key, value: setting.value }));
                return JSON.stringify({ global, webValue, settings });
            }
            setSettings(global, data, webValue = true) {
                const requestKey = this.getSetSettingsRequestKey(global, webValue, data);
                const inFlight = this.setSettingsInFlight.get(requestKey);
                if (inFlight) {
                    return inFlight;
                }
                const promise = this.putParameter('/Settings', { webValue: webValue, global: global }, data)
                    .then((result) => {
                    this.updateSettingsCache(global, webValue, data.settings);
                    return result;
                })
                    .finally(() => {
                    this.setSettingsInFlight.delete(requestKey);
                });
                this.setSettingsInFlight.set(requestKey, promise);
                return promise;
            }
            getUserSettings(keys, webvalue = true) {
                return this.getSettings(false, keys, webvalue);
            }
            getGlobalSettings(keys, webvalue = true) {
                return this.getSettings(true, keys, webvalue);
            }
            setUserSettings(data, webValue = true) {
                return this.setSettings(false, data, webValue);
            }
            setGlobalSettings(data, webValue = true) {
                return this.setSettings(true, data, webValue);
            }
            getSettingWvModel() {
                return this.getCached('settings:wvModel', () => super.getItem('/Settings/WvModel', {}, (data) => data), { ttlMs: UserService_1.SETTINGS_CACHE_TTL_MS });
            }
            // Geographic data (states & federal states)
            getStates() {
                return super.get('/States', {}).then((data) => {
                    return data;
                });
            }
            getFederalStates(stateId) {
                return super.get('/FederalStates/' + stateId, {}).then((data) => {
                    return data;
                });
            }
            getFederalStateAssignments(isHoliday) {
                return super.get('/FederalStateAssignment', { isHoliday: isHoliday }).then((data) => {
                    return data;
                });
            }
            putFederalStateAssignments(list) {
                return super.put('/FederalStateAssignment', list).then((data) => {
                    return data;
                });
            }
            // Navigation
            getAvailableNavigations() {
                return super.get('/Navigation/List', {}, (data) => {
                    return data;
                });
            }
            getNavigation(id = null) {
                return super.getItem('/Navigation', { navId: id }, (data) => {
                    return data;
                });
            }
            getNavigationItems() {
                return super.get('/Navigation/Item', {}, (data) => {
                    return data;
                });
            }
            postNewNavigation(data) {
                return super.post('/Navigation', data).then((data) => {
                    return data;
                });
            }
            putNavigation(id, data) {
                return super.put('/Navigation/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteNavigation(id) {
                return super.delete('/Navigation/' + id).then((data) => {
                    return data;
                });
            }
            // Reporting & warnings
            getCoverReportTemplates(objectType) {
                return super.get('/Reporting/Template/CoverReports/' + objectType, {}, (data) => {
                    return data;
                });
            }
            getElaborativeWarningWv() {
                return super.getItem('/elaborativeWarning', null, (data) => { return data; });
            }
            // Action log
            getActionLogEntries() {
                return super.get('/ActionLog', { dbConnectionString: angular.element('#session').data('db-connection') }, (data) => {
                    return data;
                });
            }
            postActionLogEntry(data) {
                return super.post('/ActionLog?dbConnectionString=' + angular.element('#session').data('db-connection'), data).then((data) => {
                    return data;
                });
            }
            // Survey
            getSurvey() {
                return super.getItem('/User/Survey').then((data) => { return data; });
            }
            dismissSurvey(id, performed) {
                return super.put('/User/Survey/Dismiss/' + id, { performed }).then((data) => { return data; });
            }
        };
        UserService.$inject = ['$http', '$q'];
        UserService.SETTINGS_CACHE_TTL_MS = 3 * 60 * 1000;
        UserService = UserService_1 = __decorate([
            QMC.Inject('$http', '$q'),
            QMC.Service('QMC.Home', 'UserService')
        ], UserService);
        Home.UserService = UserService;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
(() => {
    angular
        .module('QMC.Home')
        .service('UserService', QMC.Home.UserService);
})();
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        let ChangePasswordController = class ChangePasswordController {
            constructor($qui, userService, lng) {
                this.$qui = $qui;
                this.userService = userService;
                this.lng = lng;
                this.loading = false;
                this.mustChangePassword = this.getParameterByName("mustChangePassword") === "true";
                this.changePasswordErrorMessage = this.getParameterByName("errorMessage");
                if (this.mustChangePassword) {
                    $("#qmw-top-nav").hide();
                    $("#qmc-side-nav").hide();
                    $("#nav-toggle").hide();
                }
                $qui.init('einstellungen', () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
            }
            getParameterByName(name) {
                var url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
                if (!results)
                    return null;
                if (!results[2])
                    return '';
                return decodeURIComponent(results[2].replace(/\+/g, " "));
            }
            changePassword() {
                this.msg = "";
                if (this.newPassword !== this.checkPassword) {
                    this.error = true;
                    this.success = false;
                    this.msg = this.lng.translate(21003039, 'Die Kennwörter stimmen nicht überein.');
                    return;
                }
                this.userService.getCheckPasswordRules(this.newPassword).then((data) => {
                    if (data.error) {
                        this.error = true;
                        this.success = false;
                        data.errorList.map((errorListItem) => {
                            if (this.msg.length > 0) {
                                this.msg += '\r\n';
                            }
                            this.msg += errorListItem;
                        });
                        return;
                    }
                    else {
                        this.loading = true;
                        this.userService.putNewPassword(this.password, this.newPassword).then((data) => {
                            this.error = false;
                            this.success = true;
                            this.msg = this.lng.translate(20013002, 'Das Kennwort wurde erfolgreich geändert.');
                            this.password = "";
                            this.newPassword = "";
                            this.checkPassword = "";
                            if (this.mustChangePassword) {
                                document.getElementById('backButton').click();
                            }
                            this.loading = false;
                        }).catch((data) => {
                            if (data.hasOwnProperty('data'))
                                data = data.data;
                            console.log(data);
                            this.msg = "";
                            if (data.hasOwnProperty('fieldErrors')) {
                                this.error = true;
                                this.success = false;
                                if (data.fieldErrors.hasOwnProperty('currentPassword')) {
                                    data.fieldErrors.currentPassword.map((fieldError) => this.msg += fieldError + " ");
                                }
                                if (data.fieldErrors.hasOwnProperty('newPassword')) {
                                    data.fieldErrors.newPassword.map((fieldError) => this.msg += fieldError + " ");
                                }
                            }
                            else {
                                this.msg = this.lng.translate(20002047, "Ein unerwarteter Fehler ist aufgetreten");
                            }
                            this.loading = false;
                        });
                    }
                });
            }
        };
        ChangePasswordController = __decorate([
            QMC.Controller('QMC.Home', 'ChangePasswordController'),
            QMC.Inject('$qui', 'UserService', 'QmcLanguageService')
        ], ChangePasswordController);
        Home.ChangePasswordController = ChangePasswordController;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        let UserSettingsController = class UserSettingsController {
            /////////////////////////// Constructor //////////////////////////
            constructor($qui, $scope, $state, userService, lng, permissionService, terminService) {
                this.$qui = $qui;
                this.$scope = $scope;
                this.$state = $state;
                this.userService = userService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.terminService = terminService;
                //////////////////////////// Variables ///////////////////////////
                /************************* GUI Variables ************************/
                this.loading = false;
                this.globalPermission = false;
                this.planedRawDays = QMC.Common.UserSettingConstantsAndDefaults.PLANEDRAWDAYS;
                this.planedDaysFuture = QMC.Common.UserSettingConstantsAndDefaults.PLANEDDAYSFUTURE;
                this.showDateToFLS = QMC.Common.UserSettingConstantsAndDefaults.SHOWDATETOFLS;
                this.showDateToAZN = QMC.Common.UserSettingConstantsAndDefaults.SHOWDATETOAZN;
                this.showMonthFilterFls = QMC.Common.UserSettingConstantsAndDefaults.SHOWMONTHFILTERFLS;
                this.signatureHideReports = QMC.Common.UserSettingConstantsAndDefaults.SIGNATUREHIDEREPORTS;
                this.flsWeekplanningShowHoliday = QMC.Common.UserSettingConstantsAndDefaults.FLSWEEKPLANNERSHOWHOLIDAY;
                this.flsWeekplanningShowVacation = true;
                this.flsWeekplanningShowPublicHoliday = true;
                this.weekPlannerEventLength = 60;
                this.weekplannerShowUnplannableCases = false;
                this.tasksFinishedPast = QMC.Common.UserSettingConstantsAndDefaults.FINISHEDTASKSDAYS;
                this.landingPage = QMC.Common.UserSettingConstantsAndDefaults.LANDINGPAGE;
                this.flsSummaryFormatted = true;
                this.shouldLoadTableData = QMC.Common.UserSettingConstantsAndDefaults.SHOULDLOADTABLEDATA;
                this.showTimeInTable = QMC.Common.UserSettingConstantsAndDefaults.SHOWTIMEINSTEADOFDECIMAL;
                this.askDroppedService = QMC.Common.UserSettingConstantsAndDefaults.ASKDROPPEDSERVICE;
                this.dontShowIndirectHours = false;
                this.flsDocuSummaryEntrys = 0;
                //private accountingBookGenerateNumber = false;
                //private accountingBookGenerateNumberOrga = false;
                this.clientCoverTemplate = QMC.Common.Constants.GUID_EMPTY;
                this.getReweNumber = false;
                this.flsCaseFilterWithDirectCarerAllocation = true;
                this.AppointmentAddCalendarOnlyUsersEmployee = false;
                this.AppointmentAddCalendarOnlyUsersClient = false;
                this.AppointmentAddCalendarOnlyUsersAuthority = false;
                this.appointmentWidget = {
                    active: true,
                    orga: false,
                    subOrga: true,
                    endOfWeek: true,
                    daysToFuture: -1,
                    daysToPast: 0,
                };
                this.showNewsFeed = true;
                this.logoReroute = false;
                this.birthday = {
                    active: false,
                    daysToFuture: 7,
                    daysToPast: 0,
                    clients: true,
                    employees: true,
                    orga: QMC.Common.Constants.GUID_EMPTY,
                    subOrga: false
                };
                this.away = {
                    active: false,
                    daysToFuture: 7,
                    daysToPast: 0,
                    subOrga: true,
                    holiday: true,
                    disease: true
                };
                this.flsDocuSummaryPageSize = 30;
                this.daysInPast = QMC.Common.UserSettingConstantsAndDefaults.DAYSINPAST;
                this.showOnlyUnfetched = QMC.Common.UserSettingConstantsAndDefaults.SHOWONLYUNFETCHED;
                this.calendarSlotSize = 30;
                this.activateHumanize = true;
                this.humanizeHours = 24;
                this.appStates = [];
                this.institutes = [];
                this.filterText = '';
                this.federalStateList = [];
                this.federalStateAssignmentList = [];
                this.federalStateAssignmentListChanges = [];
                this.clientCoverReportTemplates = [];
                //language
                this.selectedLanguage = this.lng.getCurrentLanguageId();
                this.availableLanguages = [];
                //get values from api
                this.getValues();
                this.loadingPermission = true;
                permissionService.getPermissionsByObjectTypes([870001]).then((data) => {
                    this.globalPermission = data[0].moduleAccess;
                    this.loadingPermission = false;
                });
                $qui.init("einstellungen", () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    this.events();
                });
                this.getLandingPages();
                this.getStates();
                this.getWv();
                this.getClientCoverReportTemplates();
                this.getInstitutes();
                this.getLanguages();
            }
            isAllowed(permissions, type) {
                for (const perm of permissions) {
                    if (perm.objectType === type && perm.moduleAccess)
                        return true;
                }
                return false;
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            events() {
                this.$scope.$watch('vm.planedRawDays', () => {
                    if (this.planedRawDays < -1)
                        this.planedRawDays = -1;
                    if (this.planedRawDays > 365)
                        this.planedRawDays = 365;
                });
                this.$scope.$watch('vm.planedDaysFuture', () => {
                    if (this.planedDaysFuture < -1)
                        this.planedDaysFuture = -1;
                    if (this.planedDaysFuture > 365)
                        this.planedDaysFuture = 365;
                });
                this.$scope.$watch('vm.tasksFinishedPast', () => {
                    if (this.tasksFinishedPast < 0)
                        this.tasksFinishedPast = 0;
                    if (this.tasksFinishedPast > 365)
                        this.tasksFinishedPast = 365;
                });
            }
            //////////////////////// SERVICEFUNCTION /////////////////////////
            getValue(key) {
                return $.grep(this.settings, function (e) { return e.key === key; })[0].value;
            }
            getValueWin(key) {
                return $.grep(this.settingsWin, function (e) { return e.key === key; })[0].value;
            }
            setValue(key, value) {
                $.grep(this.settings, function (e) { return e.key === key; })[0].value = value;
            }
            setValueWin(key, value) {
                $.grep(this.settingsWin, function (e) { return e.key === key; })[0].value = value;
            }
            convertToBool(input) {
                input = input.toLowerCase();
                return input === "true";
            }
            convertToInt(input, dval) {
                const val = parseInt(input);
                return !val || isNaN(val) ? dval : val;
            }
            ////////////////////////// SERVICECALLS //////////////////////////
            getValues() {
                this.loading = true;
                const keys = [];
                keys.push("AZN.SHOWDATETO");
                keys.push("FLS.PLANEDRAWDAYS");
                keys.push("FLS.PLANEDDAYSFUTURE");
                keys.push("FLS.SIGNATURE.HIDEREPORTS");
                keys.push("FLS.SHOWDATETO");
                keys.push("FLS.SHOWMONTHFILTER");
                keys.push("FLS.WEEKPLANNER.SHOWHOLIDAY");
                keys.push("FLS.WEEKPLANNER.SHOWVACATION");
                keys.push("FLS.WEEKPLANNER.SHOWPUBLICHOLIDAY");
                keys.push("FLS.WEEKPLANNER.DEFAULTEVENTLENGTH");
                keys.push("WEEKPLANNER.SHOWUNPLANNABLECASES");
                keys.push("TASK.FINISHEDTASKSDAYS");
                keys.push("LANDINGPAGE");
                keys.push("FLS.SUMMARY.FORMATTED");
                keys.push("GLOBAL.SHOULDLOADTABLEDATA");
                keys.push("SHOWTIMEINSTEADOFDECIMAL");
                keys.push("ROSTER.ASKDROPPEDSERVICE");
                keys.push("FLS.CONTINGENT.DONTSHOWINDRECT");
                keys.push("FLS.DOCUSUMMARYITEMS");
                keys.push("FLS.SUMMARY.PAGESIZE");
                keys.push("FLS.CASE.FILTERWITHDIRECTALLOCATION");
                keys.push("NEWSFEED.IGNORE");
                keys.push("FLS.WEEKPLANNER_ONLY_CURRENT_CASES");
                keys.push("LANDINGPAGE.LOGO");
                keys.push("APPOINTMENT.WIDGET.ACTIVE");
                keys.push("APPOINTMENT.WIDGET.ORGA");
                keys.push("APPOINTMENT.WIDGET.SUBORGA");
                keys.push("APPOINTMENT.WIDGET.DAYSTOFUTURE");
                keys.push("APPOINTMENT.WIDGET.DAYSTOPAST");
                keys.push("BIRTHDAY.WIDGET.ACTIVE");
                keys.push("BIRTHDAY.WIDGET.DAYSTOFUTURE");
                keys.push("BIRTHDAY.WIDGET.DAYSTOPAST");
                keys.push("BIRTHDAY.WIDGET.CLIENTS");
                keys.push("BIRTHDAY.WIDGET.EMPLOYEES");
                keys.push("BIRTHDAY.WIDGET.ORGA");
                keys.push("BIRTHDAY.WIDGET.SUBORGA");
                keys.push("AWAY.WIDGET.ACTIVE");
                keys.push("AWAY.WIDGET.DAYSTOFUTURE");
                keys.push("AWAY.WIDGET.DAYSTOPAST");
                keys.push("AWAY.WIDGET.SUBORGA");
                keys.push("AWAY.WIDGET.HOLIDAY");
                keys.push("AWAY.WIDGET.DISEASE");
                keys.push("CALENDAR.SLOTDURATION");
                keys.push("HUMANIZETIME");
                const keysWin = [];
                keysWin.push("FLS.DEFAULTCARETYPE");
                keysWin.push("FLS.DEFAULTCONTACTTYPE");
                keysWin.push("FLS.DEFAULTACTIVITYTYPE");
                //keysWin.push("KASSENBUCH.BELEGNUMMERGENERIEREN.KLIENT");
                //keysWin.push("KASSENBUCH.BELEGNUMMERGENERIEREN.ORGA");
                keysWin.push("DLGREPORTINGSERVERJOBS.SHOWONLYUNFETCHED");
                keysWin.push("DLGREPORTINGSERVERJOBS.DAYSINPAST");
                keysWin.push("FRADECKBLATT.140000.REPORTID");
                keysWin.push("KASSENBUCH.ShowFiBuDataInSearchDialog");
                keysWin.push("TERMINPLAN.ONLYUSERS.120000");
                keysWin.push("TERMINPLAN.ONLYUSERS.140000");
                keysWin.push("TERMINPLAN.ONLYUSERS.180000");
                this.userService.getUserSettings(keys).then((data) => {
                    this.settings = data;
                    this.showDateToAZN = this.getValue("AZN.SHOWDATETO") === "" ? this.showDateToAZN : this.convertToBool(this.getValue("AZN.SHOWDATETO"));
                    this.planedRawDays = this.getValue("FLS.PLANEDRAWDAYS") === "" ? this.planedRawDays : parseFloat(this.getValue("FLS.PLANEDRAWDAYS"));
                    this.planedDaysFuture = this.getValue("FLS.PLANEDDAYSFUTURE") === "" ? this.planedDaysFuture : parseFloat(this.getValue("FLS.PLANEDDAYSFUTURE"));
                    this.signatureHideReports = this.getValue("FLS.SIGNATURE.HIDEREPORTS") === "" ? this.signatureHideReports : this.convertToBool(this.getValue("FLS.SIGNATURE.HIDEREPORTS"));
                    this.showDateToFLS = this.getValue("FLS.SHOWDATETO") === "" ? this.showDateToFLS : this.convertToBool(this.getValue("FLS.SHOWDATETO"));
                    this.showMonthFilterFls = this.getValue("FLS.SHOWMONTHFILTER") === "" ? this.showMonthFilterFls : this.convertToBool(this.getValue("FLS.SHOWMONTHFILTER"));
                    this.flsWeekplanningShowHoliday = this.getValue("FLS.WEEKPLANNER.SHOWHOLIDAY") === "" ? this.flsWeekplanningShowHoliday : this.convertToBool(this.getValue("FLS.WEEKPLANNER.SHOWHOLIDAY"));
                    this.flsWeekplanningShowVacation = this.getValue("FLS.WEEKPLANNER.SHOWVACATION") === "" ? this.flsWeekplanningShowVacation : this.convertToBool(this.getValue("FLS.WEEKPLANNER.SHOWVACATION"));
                    this.flsWeekplanningShowPublicHoliday = this.getValue("FLS.WEEKPLANNER.SHOWPUBLICHOLIDAY") === "" ? this.flsWeekplanningShowPublicHoliday : this.convertToBool(this.getValue("FLS.WEEKPLANNER.SHOWPUBLICHOLIDAY"));
                    this.weekPlannerEventLength = this.getValue("FLS.WEEKPLANNER.DEFAULTEVENTLENGTH") === "" ? this.weekPlannerEventLength : parseInt(this.getValue("FLS.WEEKPLANNER.DEFAULTEVENTLENGTH"));
                    this.weekplannerShowUnplannableCases = this.getValue("WEEKPLANNER.SHOWUNPLANNABLECASES") === "" ? this.weekplannerShowUnplannableCases : this.convertToBool(this.getValue("WEEKPLANNER.SHOWUNPLANNABLECASES"));
                    this.tasksFinishedPast = this.getValue("TASK.FINISHEDTASKSDAYS") === "" ? this.tasksFinishedPast : parseFloat(this.getValue("TASK.FINISHEDTASKSDAYS"));
                    this.landingPage = this.getValue("LANDINGPAGE");
                    this.flsSummaryFormatted = this.getValue("FLS.SUMMARY.FORMATTED") === "" ? this.flsSummaryFormatted : this.convertToBool(this.getValue("FLS.SUMMARY.FORMATTED"));
                    this.shouldLoadTableData = this.getValue("GLOBAL.SHOULDLOADTABLEDATA") === "" ? this.shouldLoadTableData : this.convertToBool(this.getValue("GLOBAL.SHOULDLOADTABLEDATA"));
                    this.showTimeInTable = this.getValue("SHOWTIMEINSTEADOFDECIMAL") === "" ? this.showTimeInTable : this.convertToBool(this.getValue("SHOWTIMEINSTEADOFDECIMAL"));
                    this.askDroppedService = this.getValue("ROSTER.ASKDROPPEDSERVICE") === "" ? this.askDroppedService : this.convertToBool(this.getValue("ROSTER.ASKDROPPEDSERVICE"));
                    this.dontShowIndirectHours = this.getValue("FLS.CONTINGENT.DONTSHOWINDRECT") === "" ? this.dontShowIndirectHours : this.convertToBool(this.getValue("FLS.CONTINGENT.DONTSHOWINDRECT"));
                    this.flsDocuSummaryEntrys = this.getValue("FLS.DOCUSUMMARYITEMS") === "" ? this.flsDocuSummaryEntrys : parseInt(this.getValue("FLS.DOCUSUMMARYITEMS"));
                    this.flsDocuSummaryPageSize = this.getValue("FLS.SUMMARY.PAGESIZE") === "" ? this.flsDocuSummaryPageSize : parseInt(this.getValue("FLS.SUMMARY.PAGESIZE"));
                    this.flsCaseFilterWithDirectCarerAllocation = this.getValue("FLS.CASE.FILTERWITHDIRECTALLOCATION") === "" ? this.flsCaseFilterWithDirectCarerAllocation : this.convertToBool(this.getValue("FLS.CASE.FILTERWITHDIRECTALLOCATION"));
                    this.showNewsFeed = this.getValue("NEWSFEED.IGNORE") === "" ? this.showNewsFeed : !this.convertToBool(this.getValue("NEWSFEED.IGNORE"));
                    this.logoReroute = this.getValue("LANDINGPAGE.LOGO") === "" ? this.logoReroute : this.convertToBool(this.getValue("LANDINGPAGE.LOGO"));
                    this.appointmentWidget.active = this.getValue("APPOINTMENT.WIDGET.ACTIVE") === "" ? this.appointmentWidget.active : this.convertToBool(this.getValue("APPOINTMENT.WIDGET.ACTIVE"));
                    this.appointmentWidget.orga = this.getValue("APPOINTMENT.WIDGET.ORGA") === "" ? this.appointmentWidget.orga : this.convertToBool(this.getValue("APPOINTMENT.WIDGET.ORGA"));
                    this.appointmentWidget.subOrga = this.getValue("APPOINTMENT.WIDGET.SUBORGA") === "" ? this.appointmentWidget.subOrga : this.convertToBool(this.getValue("APPOINTMENT.WIDGET.SUBORGA"));
                    this.appointmentWidget.daysToFuture = this.convertToInt(this.getValue("APPOINTMENT.WIDGET.DAYSTOFUTURE"), this.appointmentWidget.daysToFuture);
                    this.appointmentWidget.daysToPast = this.convertToInt(this.getValue("APPOINTMENT.WIDGET.DAYSTOPAST"), this.appointmentWidget.daysToPast);
                    this.appointmentWidget.endOfWeek = this.appointmentWidget.daysToFuture < 0;
                    if (this.appointmentWidget.endOfWeek)
                        this.appointmentWidget.daysToFuture = 7;
                    this.birthday.active = this.getValue("BIRTHDAY.WIDGET.ACTIVE") === "" ? this.birthday.active : this.convertToBool(this.getValue("BIRTHDAY.WIDGET.ACTIVE"));
                    this.birthday.daysToFuture = this.getValue("BIRTHDAY.WIDGET.DAYSTOFUTURE") === "" ? this.birthday.daysToFuture : parseInt(this.getValue("BIRTHDAY.WIDGET.DAYSTOFUTURE"));
                    this.birthday.daysToPast = this.getValue("BIRTHDAY.WIDGET.DAYSTOPAST") === "" ? this.birthday.daysToPast : parseInt(this.getValue("BIRTHDAY.WIDGET.DAYSTOPAST"));
                    this.birthday.clients = this.getValue("BIRTHDAY.WIDGET.CLIENTS") === "" ? this.birthday.clients : this.convertToBool(this.getValue("BIRTHDAY.WIDGET.CLIENTS"));
                    this.birthday.employees = this.getValue("BIRTHDAY.WIDGET.EMPLOYEES") === "" ? this.birthday.employees : this.convertToBool(this.getValue("BIRTHDAY.WIDGET.EMPLOYEES"));
                    this.birthday.orga = this.getValue("BIRTHDAY.WIDGET.ORGA") === "" ? this.birthday.orga : this.getValue("BIRTHDAY.WIDGET.ORGA");
                    this.birthday.subOrga = this.getValue("BIRTHDAY.WIDGET.SUBORGA") === "" ? this.birthday.subOrga : this.convertToBool(this.getValue("BIRTHDAY.WIDGET.SUBORGA"));
                    this.away.active = this.getValue("AWAY.WIDGET.ACTIVE") === "" ? this.away.active : this.convertToBool(this.getValue("AWAY.WIDGET.ACTIVE"));
                    this.away.daysToFuture = this.getValue("AWAY.WIDGET.DAYSTOFUTURE") === "" ? this.away.daysToFuture : parseInt(this.getValue("AWAY.WIDGET.DAYSTOFUTURE"));
                    this.away.daysToPast = this.getValue("AWAY.WIDGET.DAYSTOPAST") === "" ? this.away.daysToPast : parseInt(this.getValue("AWAY.WIDGET.DAYSTOPAST"));
                    this.away.subOrga = this.getValue("AWAY.WIDGET.SUBORGA") === "" ? this.away.subOrga : this.convertToBool(this.getValue("AWAY.WIDGET.SUBORGA"));
                    this.away.holiday = this.getValue("AWAY.WIDGET.HOLIDAY") === "" ? this.away.holiday : this.convertToBool(this.getValue("AWAY.WIDGET.HOLIDAY"));
                    this.away.disease = this.getValue("AWAY.WIDGET.DISEASE") === "" ? this.away.disease : this.convertToBool(this.getValue("AWAY.WIDGET.DISEASE"));
                    this.calendarSlotSize = this.getValue("CALENDAR.SLOTDURATION") === "" ? this.calendarSlotSize : parseInt(this.getValue("CALENDAR.SLOTDURATION"));
                    this.humanizeHours = this.getValue("HUMANIZETIME") === "" ? this.humanizeHours : parseInt(this.getValue("HUMANIZETIME"));
                    this.activateHumanize = this.humanizeHours >= 0;
                    if (this.humanizeHours < 0)
                        this.humanizeHours = 24;
                    this.userService.getUserSettings(keysWin, false).then((dataW) => {
                        this.settingsWin = dataW;
                        this.flsDefaultCareType = this.getValueWin("FLS.DEFAULTCARETYPE");
                        this.flsDefaultContactType = this.getValueWin("FLS.DEFAULTCONTACTTYPE");
                        this.flsDefaultActivityType = this.getValueWin("FLS.DEFAULTACTIVITYTYPE");
                        //this.accountingBookGenerateNumber = this.getValueWin("KASSENBUCH.BELEGNUMMERGENERIEREN.KLIENT") === "" ? this.accountingBookGenerateNumber : this.convertToBool(this.getValueWin("KASSENBUCH.BELEGNUMMERGENERIEREN.KLIENT"));
                        //this.accountingBookGenerateNumberOrga = this.getValueWin("KASSENBUCH.BELEGNUMMERGENERIEREN.ORGA") === "" ? this.accountingBookGenerateNumberOrga : this.convertToBool(this.getValueWin("KASSENBUCH.BELEGNUMMERGENERIEREN.ORGA"));
                        this.daysInPast = this.getValueWin("DLGREPORTINGSERVERJOBS.DAYSINPAST") === "" ? this.daysInPast : parseInt(this.getValueWin("DLGREPORTINGSERVERJOBS.DAYSINPAST"));
                        this.showOnlyUnfetched = this.getValueWin("DLGREPORTINGSERVERJOBS.SHOWONLYUNFETCHED") === "" ? this.showOnlyUnfetched : this.convertToBool(this.getValueWin("DLGREPORTINGSERVERJOBS.SHOWONLYUNFETCHED"));
                        this.clientCoverTemplate = this.getValueWin('FRADECKBLATT.140000.REPORTID') === '' ? this.clientCoverTemplate : this.getValueWin('FRADECKBLATT.140000.REPORTID');
                        this.getReweNumber = this.getValueWin("KASSENBUCH.ShowFiBuDataInSearchDialog") === "" ? this.getReweNumber : this.convertToBool(this.getValueWin("KASSENBUCH.ShowFiBuDataInSearchDialog"));
                        this.AppointmentAddCalendarOnlyUsersEmployee = this.getValueWin("TERMINPLAN.ONLYUSERS.120000") === "" ? this.AppointmentAddCalendarOnlyUsersEmployee : this.convertToBool(this.getValueWin("TERMINPLAN.ONLYUSERS.120000"));
                        this.AppointmentAddCalendarOnlyUsersClient = this.getValueWin("TERMINPLAN.ONLYUSERS.140000") === "" ? this.AppointmentAddCalendarOnlyUsersClient : this.convertToBool(this.getValueWin("TERMINPLAN.ONLYUSERS.140000"));
                        this.AppointmentAddCalendarOnlyUsersAuthority = this.getValueWin("TERMINPLAN.ONLYUSERS.180000") === "" ? this.AppointmentAddCalendarOnlyUsersAuthority : this.convertToBool(this.getValueWin("TERMINPLAN.ONLYUSERS.180000"));
                        this.loading = false;
                    });
                });
            }
            saveSettings() {
                var _a, _b, _c;
                const promisses = [];
                //language
                const updateLng = this.selectedLanguage !== this.lng.getCurrentLanguageId();
                if (updateLng)
                    promisses.push(this.lng.updateCurrentLanguageId(this.selectedLanguage));
                //regular
                sessionStorage.removeItem('Setting.AutoLoadTables');
                // Format values if needed
                this.planedRawDays = Math.round(this.planedRawDays);
                this.loading = true;
                this.setValue("AZN.SHOWDATETO", String(this.showDateToAZN));
                this.setValue("FLS.PLANEDRAWDAYS", String(this.planedRawDays));
                this.setValue("FLS.PLANEDDAYSFUTURE", String(this.planedDaysFuture));
                this.setValue("FLS.SHOWDATETO", String(this.showDateToFLS));
                this.setValue("FLS.SHOWMONTHFILTER", String(this.showMonthFilterFls));
                this.setValue("FLS.SIGNATURE.HIDEREPORTS", String(this.signatureHideReports));
                this.setValue("FLS.WEEKPLANNER.SHOWHOLIDAY", String(this.flsWeekplanningShowHoliday));
                this.setValue("FLS.WEEKPLANNER.SHOWVACATION", String(this.flsWeekplanningShowVacation));
                this.setValue("FLS.WEEKPLANNER.SHOWPUBLICHOLIDAY", String(this.flsWeekplanningShowPublicHoliday));
                this.setValue("FLS.WEEKPLANNER.DEFAULTEVENTLENGTH", String(this.weekPlannerEventLength));
                this.setValue("WEEKPLANNER.SHOWUNPLANNABLECASES", String(this.weekplannerShowUnplannableCases));
                this.setValue("TASK.FINISHEDTASKSDAYS", String(this.tasksFinishedPast));
                this.setValue("LANDINGPAGE", this.landingPage);
                this.setValue("FLS.SUMMARY.FORMATTED", String(this.flsSummaryFormatted));
                this.setValue("GLOBAL.SHOULDLOADTABLEDATA", String(this.shouldLoadTableData));
                this.setValue("SHOWTIMEINSTEADOFDECIMAL", String(this.showTimeInTable));
                this.setValue("ROSTER.ASKDROPPEDSERVICE", String(this.askDroppedService));
                this.setValue("FLS.CONTINGENT.DONTSHOWINDRECT", String(this.dontShowIndirectHours));
                this.setValue("FLS.DOCUSUMMARYITEMS", String(this.flsDocuSummaryEntrys));
                this.setValue("FLS.SUMMARY.PAGESIZE", String(this.flsDocuSummaryPageSize));
                this.setValue("FLS.CASE.FILTERWITHDIRECTALLOCATION", String(this.flsCaseFilterWithDirectCarerAllocation));
                this.setValue("NEWSFEED.IGNORE", String(!this.showNewsFeed));
                this.setValue("LANDINGPAGE.LOGO", String(this.logoReroute));
                this.setValue("CALENDAR.SLOTDURATION", String(this.calendarSlotSize));
                this.setValue("HUMANIZETIME", this.activateHumanize ? String(this.humanizeHours) : String(-1));
                this.setValue("APPOINTMENT.WIDGET.ACTIVE", String(this.appointmentWidget.active));
                this.setValue("APPOINTMENT.WIDGET.ORGA", String(this.appointmentWidget.orga));
                this.setValue("APPOINTMENT.WIDGET.SUBORGA", String(this.appointmentWidget.subOrga));
                this.setValue("APPOINTMENT.WIDGET.DAYSTOPAST", String(this.appointmentWidget.daysToPast));
                this.setValue("APPOINTMENT.WIDGET.DAYSTOFUTURE", String(this.appointmentWidget.endOfWeek ? -1 : this.appointmentWidget.daysToFuture));
                this.setValue("BIRTHDAY.WIDGET.ACTIVE", String(this.birthday.active));
                this.setValue("BIRTHDAY.WIDGET.DAYSTOFUTURE", String(this.birthday.daysToFuture));
                this.setValue("BIRTHDAY.WIDGET.DAYSTOPAST", String(this.birthday.daysToPast));
                this.setValue("BIRTHDAY.WIDGET.CLIENTS", String(this.birthday.clients));
                this.setValue("BIRTHDAY.WIDGET.EMPLOYEES", String(this.birthday.employees));
                this.setValue("BIRTHDAY.WIDGET.ORGA", String(this.birthday.orga));
                this.setValue("BIRTHDAY.WIDGET.SUBORGA", String(this.birthday.subOrga));
                this.setValue("AWAY.WIDGET.ACTIVE", String(this.away.active));
                this.setValue("AWAY.WIDGET.DAYSTOFUTURE", String(this.away.daysToFuture));
                this.setValue("AWAY.WIDGET.DAYSTOPAST", String(this.away.daysToPast));
                this.setValue("AWAY.WIDGET.SUBORGA", String(this.away.subOrga));
                this.setValue("AWAY.WIDGET.HOLIDAY", String(this.away.holiday));
                this.setValue("AWAY.WIDGET.DISEASE", String(this.away.disease));
                this.setValueWin("FLS.DEFAULTCARETYPE", (_a = this.flsDefaultCareType) !== null && _a !== void 0 ? _a : QMC.Common.Constants.GUID_EMPTY);
                this.setValueWin("FLS.DEFAULTCONTACTTYPE", (_b = this.flsDefaultContactType) !== null && _b !== void 0 ? _b : QMC.Common.Constants.GUID_EMPTY);
                this.setValueWin("FLS.DEFAULTACTIVITYTYPE", (_c = this.flsDefaultActivityType) !== null && _c !== void 0 ? _c : QMC.Common.Constants.GUID_EMPTY);
                //this.setValueWin("KASSENBUCH.BELEGNUMMERGENERIEREN.KLIENT", String(this.accountingBookGenerateNumber));
                //this.setValueWin("KASSENBUCH.BELEGNUMMERGENERIEREN.ORGA", String(this.accountingBookGenerateNumberOrga));
                this.setValueWin("DLGREPORTINGSERVERJOBS.SHOWONLYUNFETCHED", String(this.showOnlyUnfetched));
                this.setValueWin("DLGREPORTINGSERVERJOBS.DAYSINPAST", String(this.daysInPast));
                this.setValueWin("FRADECKBLATT.140000.REPORTID", this.clientCoverTemplate);
                this.setValueWin("KASSENBUCH.ShowFiBuDataInSearchDialog", String(this.getReweNumber));
                this.setValueWin("TERMINPLAN.ONLYUSERS.120000", String(this.AppointmentAddCalendarOnlyUsersEmployee));
                this.setValueWin("TERMINPLAN.ONLYUSERS.140000", String(this.AppointmentAddCalendarOnlyUsersClient));
                this.setValueWin("TERMINPLAN.ONLYUSERS.180000", String(this.AppointmentAddCalendarOnlyUsersAuthority));
                promisses.push(this.userService.setUserSettings({ settings: this.settings }));
                promisses.push(this.userService.setUserSettings({ settings: this.settingsWin }, false));
                Promise.all(promisses).then(() => {
                    if (updateLng)
                        $('#logoutModal').modal('show');
                }).finally(() => {
                    sessionStorage.setItem("HUMANIZETIME", String(this.activateHumanize ? this.humanizeHours : -1));
                    this.$qui.notify(this.$qui.successNote);
                    this.getValues();
                });
            }
            getLandingPages() {
                this.appStates = [];
                this.userService.getNavigationItems().then((data) => {
                    const objectTypes = [];
                    for (let i = 0; i < data.length; i++) {
                        objectTypes.push(data[i].objectType);
                    }
                    this.permissionService.getPermissionsByObjectTypes(objectTypes).then((pData) => {
                        for (let i = 0; i < data.length; i++)
                            if (data[i].objectType === 0 || this.isAllowed(pData, data[i].objectType)) {
                                this.appStates.push({
                                    text: this.lng.translate(data[i].languageTag, data[i].caption),
                                    value: data[i].link
                                });
                            }
                        this.appStates = this.appStates.sort(function (a, b) {
                            const textA = a.text.toUpperCase();
                            const textB = b.text.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                        this.appStates.unshift({ text: "", value: "" });
                    });
                });
            }
            getStates() {
                this.userService.getStates().then((data) => {
                    this.stateList = this.$qui.selectAutoMap(data, 'id', 'denotation');
                    this.selectedState = 'e8dfa43c-c3d4-408d-87d8-7bf9ccdb0ab7';
                    this.getFederalStates(this.selectedState);
                    this.$scope.$watch('vm.selectedState', (newVal, oldVal) => {
                        if (newVal === oldVal)
                            return;
                        this.getFederalStates(this.selectedState);
                    });
                });
            }
            getInstitutes() {
                this.userService.getInstituteList().then((data) => {
                    this.institutes = data.map((x) => { return { text: x.caption, value: x.objectId }; }).sort((a, b) => { return (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0); });
                    this.institutes.unshift({ text: this.lng.translate(20000319, '- Eigene Organization -'), value: '00000000-0000-0000-0000-000000000000' });
                });
            }
            getLanguages() {
                this.lng.getLanguages().then(data => {
                    this.availableLanguages = data.map(x => ({ text: x.name, value: x.id }));
                });
            }
            getClientCoverReportTemplates(objectType = 140000) {
                this.userService.getCoverReportTemplates(objectType).then((data) => {
                    for (const item of data) {
                        switch (item.reportType) {
                            case 7000:
                                item.reportType = this.lng.translate(20015036, 'Vorlage');
                                break;
                            case 3000:
                                item.reportType = this.lng.translate(20015038, 'Tabellenkalkulation');
                                break;
                            default:
                                item.reportType = '';
                                break;
                        }
                    }
                    this.clientCoverReportTemplates = data.map(x => ({ text: x.name, value: x.objectId, group: x.reportType }));
                    if (this.clientCoverTemplate === QMC.Common.Constants.GUID_EMPTY)
                        this.clientCoverTemplate = data[0].objectId;
                });
            }
            getFederalStates(selectedState) {
                this.userService.getFederalStates(selectedState).then((data) => {
                    this.federalStateList = data;
                    this.getFederalStateAssignments(this.isHoliday);
                });
            }
            openModal(isHoliday) {
                if (isHoliday !== this.isHoliday) {
                    this.isHoliday = isHoliday;
                }
                this.getFederalStateAssignments(this.isHoliday);
            }
            getFederalStateAssignments(isHoliday) {
                this.userService.getFederalStateAssignments(isHoliday).then((assignments) => {
                    this.federalStateAssignmentList = this.federalStateList.map((federalState) => {
                        const assignment = assignments.find((item) => item.federalStateId === federalState.id);
                        return { federalStateId: federalState.id, assignmentId: (assignment !== undefined) ? assignment.id : null, denotation: federalState.denotation, show: (assignment !== undefined), isHoliday: isHoliday };
                    });
                });
            }
            federalStateAssignmentListItemChanged(changedItem) {
                this.federalStateAssignmentListChanges.push(changedItem);
            }
            putFederalStateAssignmentList() {
                $('#selectFederalStateModal').modal('hide');
                this.userService.putFederalStateAssignments(this.federalStateAssignmentListChanges).then(() => {
                    this.federalStateAssignmentListChanges = [];
                });
                this.federalStateAssignmentListChanges = [];
            }
            getWv() {
                this.userService.getSettingWvModel().then((data) => {
                    this.flsContactTypes = data.flsContactTypeWvModel.map(x => ({ value: x.objectId, text: x.name }));
                    this.flsCareTypes = data.flsCareTypeWvModel.map(x => ({ value: x.objectId, text: x.name }));
                    this.flsActivityTypes = data.flsActivityTypeWvModel.map(x => ({ value: x.objectId, text: x.name }));
                });
            }
            resetBrowserCache() {
                localStorage.clear();
                window.location.reload(true);
            }
        };
        UserSettingsController = __decorate([
            QMC.Controller('QMC.Home', 'UserSettingsController'),
            QMC.Inject('$qui', '$scope', '$state', 'UserService', 'QmcLanguageService', 'QmcPermissionService', 'TerminService')
        ], UserSettingsController);
        Home.UserSettingsController = UserSettingsController;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        let UserGlobalSettingsController = class UserGlobalSettingsController {
            /////////////////////////// Constructor //////////////////////////
            constructor($qui, $scope, userService, lng, permissionService, flsService) {
                this.$qui = $qui;
                this.$scope = $scope;
                this.userService = userService;
                this.lng = lng;
                this.permissionService = permissionService;
                this.flsService = flsService;
                //////////////////////////// Variables ///////////////////////////
                /************************* GUI Variables ************************/
                this.loading = false;
                this.globalPermission = false;
                this.boolean = true;
                this.signingPersonIsClient = false;
                this.inactivityTime = QMC.Common.UserSettingConstantsAndDefaults.INACTIVITYTIMEOUT;
                this.flsMinutesToSign = QMC.Common.UserSettingConstantsAndDefaults.FLSMINUTESTOSIGN;
                this.landingPage = QMC.Common.UserSettingConstantsAndDefaults.LANDINGPAGE;
                this.shouldLoadTableData = QMC.Common.UserSettingConstantsAndDefaults.SHOULDLOADTABLEDATA;
                this.defaultNavId = QMC.Common.UserSettingConstantsAndDefaults.NAVIGATION_DEFAULT_ID;
                this.defaultSigningPersonId = QMC.Common.UserSettingConstantsAndDefaults.DEFAULTSIGNINGPERSON;
                this.defaultSigningReasonId = QMC.Common.UserSettingConstantsAndDefaults.DEFAULTSIGNINGREASON;
                this.defaultSigningReasonText = "";
                this.flsSignatureReasonNotMandatory = false;
                this.blockSignatureModal = false;
                this.daysToHighlightCases = 0;
                this.dontShowIndirectHours = false;
                this.createAdditionalFls = false;
                this.createAdditionalFlsText = "";
                this.flsDocuSummaryEntrys = 0;
                this.flsDistributeHours = QMC.Common.UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN;
                this.flsDistributeHoursFix = QMC.Common.UserSettingConstantsAndDefaults.FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX;
                this.flsResetTimeForManualDuration = QMC.Common.UserSettingConstantsAndDefaults.GC_FLS_NEUMEHREREBETREUTE_ZEITRESETBEIVERTEILUNG;
                this.serverJobPollingTimer = QMC.Common.UserSettingConstantsAndDefaults.SERVERJOBTIMERINTERVALLINSEC;
                this.weekplannerShowUnplannableCases = false;
                this.flsWeekplannerIncludeFutureCases = QMC.Common.UserSettingConstantsAndDefaults.FLS_WEEKPLANNER_INCLUDE_FUTURE_CASES;
                this.flsWeekplannerIncludePastCases = false;
                this.dontShowRawDocusIfEmptyIsAllowed = false;
                this.flsCaseFilterWithDirectCarerAllocation = true;
                this.AppointmentAddCalendarOnlyUsersEmployee = false;
                this.AppointmentAddCalendarOnlyUsersClient = false;
                this.AppointmentAddCalendarOnlyUsersAuthority = false;
                this.flsHideQuickDrivingCost = false;
                this.flsAllowEmptyDrivingCost = false;
                this.flsPredfinedTitleMode = '0';
                this.flsPredfinedTitle = '';
                this.logoReroute = false;
                this.rosterShowInactive = false;
                this.flsDefaultAccountabilityRule = undefined;
                this.inquireStampinOnLogin = QMC.Common.UserSettingConstantsAndDefaults.INQUIRE_STAMPIN_ON_LOGIN;
                this.inquireStampOutOnLogout = QMC.Common.UserSettingConstantsAndDefaults.INQUIRE_STAMPOUT_ON_LOGOUT;
                this.saVaccination = 'impfung; impfen';
                this.saDocVisit = 'arzt; doktor';
                this.saDisease = 'krank; krankheit; grippe; fieber';
                this.saAppointment = 'termin; verabredung; meeting';
                this.saAbsenteeism = 'abwesend; abwesenheit';
                this.saMessage = 'nachricht; mail; meldung';
                this.saTask = 'aufgabe; task';
                this.saDocument = 'dokument';
                this.saAccountingBook = 'kassenbuch';
                this.saContactperson = 'kontakt; kontaktperson';
                this.flsShowManuelTime = true;
                this.richTextImages = {
                    disabled: false,
                    size: 4,
                    height: 1080,
                    width: 1920
                };
                this.appStates = [];
                this.flsTitleSetting = [
                    { text: this.lng.translate(20013150, 'Systemvorgabe'), value: '0' },
                    { text: this.lng.translate(20013151, 'Leer'), value: '1' },
                    { text: this.lng.translate(20013152, 'Eigene Vorgabe'), value: '2' }
                ];
                this.flsAccountabilityRules = [];
                //get values from api
                this.getValues();
                this.loadingPermission = true;
                permissionService.getPermissionsByObjectType(870000).then((data) => {
                    this.globalPermission = data[0].moduleAccess;
                    this.loadingPermission = false;
                });
                this.userService.getAvailableNavigations().then((data => {
                    this.navigations = data.map((obj) => ({ value: obj.id, text: obj.caption }));
                }));
                this.flsService.getSignatureWv().then((data => {
                    this.flsSigningPersons = data.signingPersons.map((obj) => ({ value: obj.objectId, text: obj.name }));
                    this.flsSigningReasons = data.reasons.map((obj) => ({ value: obj.objectId, text: obj.name }));
                }));
                $qui.init("einstellungen", () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                    this.events();
                });
                this.flsService.getFlsDocumentationWvModel().then(data => {
                    this.flsAccountabilityRules = [
                        { value: undefined, text: '' },
                        ...data[0].documentationCarerWvModel.abrechenbarkeitWv.map(x => ({ value: x.objectId.toLocaleLowerCase(), text: x.caption }))
                    ];
                });
                this.getLandingPages();
                this.$scope.$watchCollection('vm.defaultSigningPersonId', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    this.setSigningPersonSettingVisibility();
                });
                this.setSigningPersonSettingVisibility();
            }
            setSigningPersonSettingVisibility() {
                if (this.defaultSigningPersonId == QMC.Common.Constants.SIGNATURE_SIGNING_PERSON_CLIENT) {
                    this.defaultSigningReasonId = QMC.Common.Constants.GUID_EMPTY;
                    this.defaultSigningReasonText = '';
                    this.signingPersonIsClient = true;
                }
                else
                    this.signingPersonIsClient = false;
            }
            isAllowed(permissions, type) {
                for (let i = 0; i < permissions.length; i++) {
                    if (permissions[i].objectType === type && permissions[i].moduleAccess)
                        return true;
                }
                return false;
            }
            ////////////////////////// DISPLAYLOGIC //////////////////////////
            events() {
            }
            //////////////////////// SERVICEFUNCTION /////////////////////////
            getValueGlobal(key) {
                return $.grep(this.globalSettings, function (e) { return e.key === key; })[0].value;
            }
            setValueGlobal(key, value) {
                $.grep(this.globalSettings, function (e) { return e.key === key; })[0].value = value;
            }
            getValueGlobalWin(key) {
                return $.grep(this.globalSettingsWin, function (e) { return e.key === key; })[0].value;
            }
            setValueGlobalWin(key, value) {
                $.grep(this.globalSettingsWin, function (e) { return e.key === key; })[0].value = value;
            }
            convertToBool(input) {
                input = input.toLowerCase();
                return input === "true";
            }
            ////////////////////////// SERVICECALLS //////////////////////////
            getValues() {
                this.loading = true;
                let keys = [
                    "FLS.MINUTESTOSIGN",
                    "SECURITY.INACTIVITYTIMEOUT",
                    "GLOBAL.LANDINGPAGE",
                    "GLOBAL.SHOULDLOADTABLEDATA",
                    "GLOBAL.NAVIGATION.WEB",
                    "FLS.SIGNATURE.BLOCK",
                    "FLS.CASE.DAYSTOHIGHLIGHT",
                    "FLS.CONTINGENT.DONTSHOWINDRECT",
                    "FLS.ADDITIONAL_TIMELESS_ENTRY",
                    "FLS.ADDITIONAL_TIMELESS_ENTRY_TEXT",
                    "FLS.CASE.FILTERWITHDIRECTALLOCATION",
                    "FLS.DOCUSUMMARYITEMS",
                    "FLS.DONTSHOWRAWIFEMPTYDOCUSALLOWED",
                    "FLS.WEEKPLANNER_INCLUDE_FUTURE_CASES",
                    "FLS.WEEKPLANNER_INCLUDE_PAST_CASES",
                    "WEEKPLANNER.SHOWUNPLANNABLECASES",
                    "FLS.HIDE_QUICK_DRIVINGCOST",
                    "TIMECLOCK.INQUIRE_STAMPIN_ON_LOGIN",
                    "TIMECLOCK.INQUIRE_STAMPOUT_ON_LOGOUT",
                    "SMARTACTIONS.VACCINATION",
                    "SMARTACTIONS.DOCVISIT",
                    "SMARTACTIONS.DISEASE",
                    "SMARTACTIONS.APPOINTMENT",
                    "SMARTACTIONS.ABSENTEEISM",
                    "SMARTACTIONS.INTERNALMESSAGE",
                    "SMARTACTIONS.TASK",
                    "SMARTACTIONS.DOCUMENT",
                    "SMARTACTIONS.ACCOUNTINGBOOK",
                    "SMARTACTIONS.CONTACTPERSON",
                    "LANDINGPAGE.LOGO",
                    "RICHTEXTIMAGES"
                ];
                const keysWin = [
                    "FLS.FAHRT.ERLAUBE_LEERE_DATENSAETZE",
                    "FLS.SIGNATURE.DEFAULTSIGNINGPERSON",
                    "FLS.SIGNATURE.DEFAULTSIGNINGREASON",
                    "FLS.SIGNATURE.DEFAULTSIGNINGREASONTEXT",
                    "FLS.SIGNATURE.REASONNOTMANDATORY",
                    "FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN",
                    "FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX",
                    "GC_FLS_NEUMEHREREBETREUTE_ZEITRESETBEIVERTEILUNG",
                    "SERVERJOBTIMERINTERVALLINSEC",
                    "TERMINPLAN.ONLYUSERS.GLOBAL.120000",
                    "TERMINPLAN.ONLYUSERS.GLOBAL.140000",
                    "TERMINPLAN.ONLYUSERS.GLOBAL.180000",
                    "FLS.DOKU.BERICHTTITELVORGABE",
                    "FLS.DOKU.BERICHTTITEL",
                    "DIENSTPLAN.SHOWINACTIVEPERSONS",
                    "FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER",
                    "FLS.DEFAULTACCOUNTABILITY"
                ];
                this.userService.getGlobalSettings(keys).then((data) => {
                    this.globalSettings = data;
                    this.flsMinutesToSign = this.getValueGlobal("FLS.MINUTESTOSIGN") === "" ? this.flsMinutesToSign : parseFloat(this.getValueGlobal("FLS.MINUTESTOSIGN"));
                    this.inactivityTime = this.getValueGlobal("SECURITY.INACTIVITYTIMEOUT") === "" ? this.inactivityTime : parseFloat(this.getValueGlobal("SECURITY.INACTIVITYTIMEOUT"));
                    this.landingPage = this.getValueGlobal("GLOBAL.LANDINGPAGE");
                    this.shouldLoadTableData = this.getValueGlobal("GLOBAL.SHOULDLOADTABLEDATA") === "" ? this.shouldLoadTableData : this.convertToBool(this.getValueGlobal("GLOBAL.SHOULDLOADTABLEDATA"));
                    this.defaultNavId = this.getValueGlobal("GLOBAL.NAVIGATION.WEB") === "" ? this.defaultNavId : this.getValueGlobal("GLOBAL.NAVIGATION.WEB");
                    this.blockSignatureModal = this.getValueGlobal("FLS.SIGNATURE.BLOCK") === "" ? this.blockSignatureModal : this.convertToBool(this.getValueGlobal("FLS.SIGNATURE.BLOCK"));
                    this.daysToHighlightCases = this.getValueGlobal("FLS.CASE.DAYSTOHIGHLIGHT") === "" ? this.daysToHighlightCases : parseInt(this.getValueGlobal("FLS.CASE.DAYSTOHIGHLIGHT"));
                    this.dontShowIndirectHours = this.getValueGlobal("FLS.CONTINGENT.DONTSHOWINDRECT") === "" ? this.dontShowIndirectHours : this.convertToBool(this.getValueGlobal("FLS.CONTINGENT.DONTSHOWINDRECT"));
                    this.createAdditionalFls = this.getValueGlobal("FLS.ADDITIONAL_TIMELESS_ENTRY") === "" ? this.dontShowIndirectHours : this.convertToBool(this.getValueGlobal("FLS.ADDITIONAL_TIMELESS_ENTRY"));
                    this.createAdditionalFlsText = this.createAdditionalFls ? this.getValueGlobal("FLS.ADDITIONAL_TIMELESS_ENTRY_TEXT") : "";
                    this.flsDocuSummaryEntrys = this.getValueGlobal("FLS.DOCUSUMMARYITEMS") === "" ? this.flsDocuSummaryEntrys : parseInt(this.getValueGlobal("FLS.DOCUSUMMARYITEMS"));
                    this.flsWeekplannerIncludeFutureCases = this.getValueGlobal("FLS.WEEKPLANNER_INCLUDE_FUTURE_CASES") === "" ? this.flsWeekplannerIncludeFutureCases : this.convertToBool(this.getValueGlobal("FLS.WEEKPLANNER_INCLUDE_FUTURE_CASES"));
                    this.flsWeekplannerIncludePastCases = this.getValueGlobal("FLS.WEEKPLANNER_INCLUDE_PAST_CASES") === "" ? this.flsWeekplannerIncludePastCases : this.convertToBool(this.getValueGlobal("FLS.WEEKPLANNER_INCLUDE_PAST_CASES"));
                    this.weekplannerShowUnplannableCases = this.getValueGlobal("WEEKPLANNER.SHOWUNPLANNABLECASES") === "" ? this.weekplannerShowUnplannableCases : this.convertToBool(this.getValueGlobal("WEEKPLANNER.SHOWUNPLANNABLECASES"));
                    this.dontShowRawDocusIfEmptyIsAllowed = this.getValueGlobal("FLS.DONTSHOWRAWIFEMPTYDOCUSALLOWED") === "" ? this.dontShowRawDocusIfEmptyIsAllowed : this.convertToBool(this.getValueGlobal("FLS.DONTSHOWRAWIFEMPTYDOCUSALLOWED"));
                    this.inquireStampinOnLogin = this.getValueGlobal("TIMECLOCK.INQUIRE_STAMPIN_ON_LOGIN") === "" ? this.inquireStampinOnLogin : this.convertToBool(this.getValueGlobal("TIMECLOCK.INQUIRE_STAMPIN_ON_LOGIN"));
                    this.inquireStampOutOnLogout = this.getValueGlobal("TIMECLOCK.INQUIRE_STAMPOUT_ON_LOGOUT") === "" ? this.inquireStampOutOnLogout : this.convertToBool(this.getValueGlobal("TIMECLOCK.INQUIRE_STAMPOUT_ON_LOGOUT"));
                    this.flsCaseFilterWithDirectCarerAllocation = this.getValueGlobal("FLS.CASE.FILTERWITHDIRECTALLOCATION") === "" ? this.flsCaseFilterWithDirectCarerAllocation : this.convertToBool(this.getValueGlobal("FLS.CASE.FILTERWITHDIRECTALLOCATION"));
                    this.saVaccination = this.getValueGlobal("SMARTACTIONS.VACCINATION");
                    this.saDocVisit = this.getValueGlobal("SMARTACTIONS.DOCVISIT");
                    this.saDisease = this.getValueGlobal("SMARTACTIONS.DISEASE");
                    this.saAppointment = this.getValueGlobal("SMARTACTIONS.APPOINTMENT");
                    this.saTask = this.getValueGlobal("SMARTACTIONS.TASK");
                    this.saAbsenteeism = this.getValueGlobal("SMARTACTIONS.ABSENTEEISM");
                    this.saMessage = this.getValueGlobal("SMARTACTIONS.INTERNALMESSAGE");
                    this.saDocument = this.getValueGlobal("SMARTACTIONS.DOCUMENT");
                    this.saAccountingBook = this.getValueGlobal("SMARTACTIONS.ACCOUNTINGBOOK");
                    this.saContactperson = this.getValueGlobal("SMARTACTIONS.CONTACTPERSON");
                    this.flsHideQuickDrivingCost = this.getValueGlobal("FLS.HIDE_QUICK_DRIVINGCOST") === "" ? this.flsHideQuickDrivingCost : this.convertToBool(this.getValueGlobal("FLS.HIDE_QUICK_DRIVINGCOST"));
                    this.logoReroute = this.getValueGlobal("LANDINGPAGE.LOGO") === "" ? this.logoReroute : this.convertToBool(this.getValueGlobal("LANDINGPAGE.LOGO"));
                    this.richTextImages = this.getValueGlobal("RICHTEXTIMAGES") === "" ? this.richTextImages : JSON.parse(this.getValueGlobal("RICHTEXTIMAGES"));
                    this.userService.getGlobalSettings(keysWin, false).then((data2) => {
                        this.globalSettingsWin = data2;
                        this.flsAllowEmptyDrivingCost = this.getValueGlobalWin("FLS.FAHRT.ERLAUBE_LEERE_DATENSAETZE") === "" ? this.flsAllowEmptyDrivingCost : this.convertToBool(this.getValueGlobalWin("FLS.FAHRT.ERLAUBE_LEERE_DATENSAETZE"));
                        this.defaultSigningPersonId = this.getValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGPERSON") === "" ? this.defaultSigningPersonId : this.getValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGPERSON");
                        this.defaultSigningReasonId = this.getValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGREASON") === "" ? this.defaultSigningReasonId : this.getValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGREASON");
                        this.defaultSigningReasonText = this.getValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGREASONTEXT");
                        this.flsSignatureReasonNotMandatory = this.convertToBool(this.getValueGlobalWin("FLS.SIGNATURE.REASONNOTMANDATORY"));
                        this.flsDistributeHours = this.getValueGlobalWin("FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN") === "" ? this.flsDistributeHours : this.convertToBool(this.getValueGlobalWin("FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN"));
                        this.flsDistributeHoursFix = this.getValueGlobalWin("FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX") === "" ? this.flsDistributeHoursFix : this.convertToBool(this.getValueGlobalWin("FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX"));
                        this.flsResetTimeForManualDuration = this.getValueGlobalWin("GC_FLS_NEUMEHREREBETREUTE_ZEITRESETBEIVERTEILUNG") === "" ? this.flsResetTimeForManualDuration : this.convertToBool(this.getValueGlobalWin("GC_FLS_NEUMEHREREBETREUTE_ZEITRESETBEIVERTEILUNG"));
                        this.serverJobPollingTimer = this.getValueGlobalWin("SERVERJOBTIMERINTERVALLINSEC") === "" ? this.serverJobPollingTimer : parseInt(this.getValueGlobalWin("SERVERJOBTIMERINTERVALLINSEC"));
                        this.AppointmentAddCalendarOnlyUsersEmployee = this.getValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.120000") === "" ? this.AppointmentAddCalendarOnlyUsersEmployee : this.convertToBool(this.getValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.120000"));
                        this.AppointmentAddCalendarOnlyUsersClient = this.getValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.140000") === "" ? this.AppointmentAddCalendarOnlyUsersClient : this.convertToBool(this.getValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.140000"));
                        this.AppointmentAddCalendarOnlyUsersAuthority = this.getValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.180000") === "" ? this.AppointmentAddCalendarOnlyUsersAuthority : this.convertToBool(this.getValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.180000"));
                        this.flsPredfinedTitleMode = this.getValueGlobalWin("FLS.DOKU.BERICHTTITELVORGABE") === "" ? this.flsPredfinedTitleMode : this.getValueGlobalWin("FLS.DOKU.BERICHTTITELVORGABE");
                        this.flsPredfinedTitle = this.getValueGlobalWin("FLS.DOKU.BERICHTTITEL") === "" ? this.flsPredfinedTitle : this.getValueGlobalWin("FLS.DOKU.BERICHTTITEL");
                        this.rosterShowInactive = this.getValueGlobalWin("DIENSTPLAN.SHOWINACTIVEPERSONS") === "" ? this.rosterShowInactive : this.convertToBool(this.getValueGlobalWin("DIENSTPLAN.SHOWINACTIVEPERSONS"));
                        this.flsShowManuelTime = this.getValueGlobalWin("FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER") === "" ? this.flsShowManuelTime : this.convertToBool(this.getValueGlobalWin("FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER"));
                        this.flsDefaultAccountabilityRule = this.getValueGlobalWin("FLS.DEFAULTACCOUNTABILITY") === "" ? this.flsDefaultAccountabilityRule : this.getValueGlobalWin("FLS.DEFAULTACCOUNTABILITY").toLocaleLowerCase();
                        this.loading = false;
                    });
                });
            }
            saveSettings() {
                var _a;
                // Format values if needed
                this.loading = true;
                this.setValueGlobal("FLS.MINUTESTOSIGN", String(this.flsMinutesToSign));
                this.setValueGlobal("SECURITY.INACTIVITYTIMEOUT", String(this.inactivityTime));
                this.setValueGlobal("GLOBAL.LANDINGPAGE", this.landingPage);
                this.setValueGlobal("GLOBAL.SHOULDLOADTABLEDATA", String(this.shouldLoadTableData));
                this.setValueGlobal("GLOBAL.NAVIGATION.WEB", this.defaultNavId);
                this.setValueGlobal("FLS.SIGNATURE.BLOCK", String(this.blockSignatureModal));
                this.setValueGlobal("FLS.CASE.DAYSTOHIGHLIGHT", String(this.daysToHighlightCases));
                this.setValueGlobal("FLS.CONTINGENT.DONTSHOWINDRECT", String(this.dontShowIndirectHours));
                this.setValueGlobal("FLS.ADDITIONAL_TIMELESS_ENTRY", String(this.createAdditionalFls));
                this.setValueGlobal("FLS.ADDITIONAL_TIMELESS_ENTRY_TEXT", this.createAdditionalFls ? this.createAdditionalFlsText : "");
                this.setValueGlobal("FLS.DOCUSUMMARYITEMS", String(this.flsDocuSummaryEntrys));
                this.setValueGlobal("FLS.WEEKPLANNER_INCLUDE_FUTURE_CASES", String(this.flsWeekplannerIncludeFutureCases));
                this.setValueGlobal("FLS.WEEKPLANNER_INCLUDE_PAST_CASES", String(this.flsWeekplannerIncludePastCases));
                this.setValueGlobal("WEEKPLANNER.SHOWUNPLANNABLECASES", String(this.weekplannerShowUnplannableCases));
                this.setValueGlobal("FLS.DONTSHOWRAWIFEMPTYDOCUSALLOWED", String(this.dontShowRawDocusIfEmptyIsAllowed));
                this.setValueGlobal("TIMECLOCK.INQUIRE_STAMPIN_ON_LOGIN", String(this.inquireStampinOnLogin));
                this.setValueGlobal("TIMECLOCK.INQUIRE_STAMPOUT_ON_LOGOUT", String(this.inquireStampinOnLogin));
                this.setValueGlobal("FLS.CASE.FILTERWITHDIRECTALLOCATION", String(this.flsCaseFilterWithDirectCarerAllocation));
                this.setValueGlobal("SMARTACTIONS.VACCINATION", this.saVaccination);
                this.setValueGlobal("SMARTACTIONS.DOCVISIT", this.saDocVisit);
                this.setValueGlobal("SMARTACTIONS.DISEASE", this.saDisease);
                this.setValueGlobal("SMARTACTIONS.APPOINTMENT", this.saAppointment);
                this.setValueGlobal("SMARTACTIONS.TASK", this.saTask);
                this.setValueGlobal("SMARTACTIONS.ABSENTEEISM", this.saAbsenteeism);
                this.setValueGlobal("SMARTACTIONS.INTERNALMESSAGE", this.saMessage);
                this.setValueGlobal("SMARTACTIONS.DOCUMENT", this.saDocument);
                this.setValueGlobal("SMARTACTIONS.ACCOUNTINGBOOK", this.saAccountingBook);
                this.setValueGlobal("SMARTACTIONS.CONTACTPERSON", this.saContactperson);
                this.setValueGlobal("FLS.HIDE_QUICK_DRIVINGCOST", String(this.flsHideQuickDrivingCost));
                this.setValueGlobal("LANDINGPAGE.LOGO", String(this.logoReroute));
                this.setValueGlobal("RICHTEXTIMAGES", JSON.stringify(this.richTextImages));
                this.setValueGlobalWin("FLS.FAHRT.ERLAUBE_LEERE_DATENSAETZE", String(this.flsAllowEmptyDrivingCost));
                this.setValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGPERSON", String(this.defaultSigningPersonId));
                this.setValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGREASON", String(this.defaultSigningReasonId));
                this.setValueGlobalWin("FLS.SIGNATURE.DEFAULTSIGNINGREASONTEXT", this.flsSignatureReasonNotMandatory ? '' : this.defaultSigningReasonText);
                this.setValueGlobalWin("FLS.SIGNATURE.REASONNOTMANDATORY", String(this.flsSignatureReasonNotMandatory));
                this.setValueGlobalWin("FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN", String(this.flsDistributeHours));
                this.setValueGlobalWin("FLS_NEUMEHREREBETREUTE_ZEITAUFFAELLEVERTEILEN_FIX", String(this.flsDistributeHoursFix));
                this.setValueGlobalWin("GC_FLS_NEUMEHREREBETREUTE_ZEITRESETBEIVERTEILUNG", String(this.flsResetTimeForManualDuration));
                this.setValueGlobalWin("SERVERJOBTIMERINTERVALLINSEC", String(this.serverJobPollingTimer));
                this.setValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.120000", String(this.AppointmentAddCalendarOnlyUsersEmployee));
                this.setValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.140000", String(this.AppointmentAddCalendarOnlyUsersClient));
                this.setValueGlobalWin("TERMINPLAN.ONLYUSERS.GLOBAL.180000", String(this.AppointmentAddCalendarOnlyUsersAuthority));
                this.setValueGlobalWin("FLS.DOKU.BERICHTTITELVORGABE", this.flsPredfinedTitleMode);
                this.setValueGlobalWin("FLS.DOKU.BERICHTTITEL", this.flsPredfinedTitleMode === '2' ? this.flsPredfinedTitle : '');
                this.setValueGlobalWin("DIENSTPLAN.SHOWINACTIVEPERSONS", String(this.rosterShowInactive));
                this.setValueGlobalWin("FLS.ZEITPLANUNG.SHOW_MANUELLE_DAUER", String(this.flsShowManuelTime));
                this.setValueGlobalWin("FLS.DEFAULTACCOUNTABILITY", String((_a = this.flsDefaultAccountabilityRule) !== null && _a !== void 0 ? _a : ''));
                this.userService.setGlobalSettings({ settings: this.globalSettings }).then((data) => {
                    this.userService.setGlobalSettings({ settings: this.globalSettingsWin }, false).then((data) => {
                        this.$qui.notify(this.$qui.successNote);
                        this.loading = false;
                        sessionStorage.removeItem('Setting.AutoLoadTables');
                        sessionStorage.removeItem(QMC.Common.Constants.SMARTACTIONCACHE);
                    });
                });
                window['snResizeSettings'] = this.richTextImages;
            }
            getLandingPages() {
                this.appStates = [];
                this.userService.getNavigationItems().then((data) => {
                    let objectTypes = [];
                    for (let i = 0; i < data.length; i++) {
                        console.log(data[i], data[i].objectType);
                        objectTypes.push(data[i].objectType);
                    }
                    this.permissionService.getPermissionsByObjectTypes(objectTypes).then((pData) => {
                        for (let i = 0; i < data.length; i++)
                            if (data[i].objectType === 0 || this.isAllowed(pData, data[i].objectType)) {
                                this.appStates.push({
                                    text: this.lng.translate(data[i].languageTag, data[i].caption),
                                    value: data[i].link
                                });
                            }
                        this.appStates = this.appStates.sort(function (a, b) {
                            var textA = a.text.toUpperCase();
                            var textB = b.text.toUpperCase();
                            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                        });
                        this.appStates.unshift({ text: "", value: "" });
                    });
                });
            }
        };
        UserGlobalSettingsController = __decorate([
            QMC.Controller('QMC.Home', 'UserGlobalSettingsController'),
            QMC.Inject('$qui', '$scope', 'UserService', 'QmcLanguageService', 'QmcPermissionService', 'FachleistungService')
        ], UserGlobalSettingsController);
        Home.UserGlobalSettingsController = UserGlobalSettingsController;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        let NewsFeedDirective = class NewsFeedDirective {
            constructor($http, $sce, userService) {
                this.$http = $http;
                this.$sce = $sce;
                this.userService = userService;
                this.restrict = 'E';
                this.templateUrl = './NewsFeed';
                this.replace = true;
                this.scope = {};
                this.ignoreNewsFeed = false;
                this.loading = {
                    feed: false,
                    setting: false
                };
                this.link = (scope) => {
                    scope.ignore = false;
                    scope.loadLink = false;
                    this.loading.feed = true;
                    scope.feed = [];
                    this.loading.setting = true;
                    this.userService.getUserSettings(['NEWSFEED.LAST', 'NEWSFEED.IGNORE', 'NEWSFEED.URL']).then((dataSettings) => {
                        if (dataSettings[0] !== '')
                            this.lastMessageId = dataSettings[0].value;
                        this.ignoreNewsFeed = dataSettings[1].value.toLowerCase().trim() === 'true';
                        this.loading.setting = false;
                        scope.ignore = dataSettings[1].value.toLowerCase() === 'true';
                        const url = dataSettings[2].value !== '' ? dataSettings[2].value : 'https://update.daarwin.myneva.cloud/technews-de.xml';
                        this.$http({
                            url: url,
                            method: 'GET',
                            cache: false,
                            headers: { 'Content-Type': 'application/xml' },
                            transformResponse: function (data) { return $.parseXML(data); }
                        }).then((res) => {
                            const items = res.data.getElementsByTagName('item');
                            for (let i = 0; i < items.length; i++) {
                                const item = items[i];
                                if (!item)
                                    continue;
                                scope.feed.push({
                                    title: this.$sce.trustAsHtml(item.getElementsByTagName('title')[0] ? item.getElementsByTagName('title')[0].innerHTML : ''),
                                    text: this.$sce.trustAsHtml(item.getElementsByTagName('description')[0] ? item.getElementsByTagName('description')[0].innerHTML.replace(']]>', '') : ''),
                                    link: item.getElementsByTagName('link')[0] ? item.getElementsByTagName('link')[0].textContent : '',
                                    date: this.uniqueDate(scope.feed, item.getElementsByTagName('pubDate')[0] ? item.getElementsByTagName('pubDate')[0].textContent : '')
                                });
                            }
                            this.loading.feed = false;
                            if (scope.feed.length > 0) {
                                scope.current = scope.feed[0];
                                this.showNewsFeed(scope);
                                scope.selectedItem = scope.current.date;
                            }
                        });
                    });
                    scope.dismiss = function (...args) {
                        const settings = {
                            settings: [
                                { key: 'NEWSFEED.LAST', value: scope.feed[0].date },
                                { key: 'NEWSFEED.IGNORE', value: args[1].toString() }
                            ]
                        };
                        this.userService.setUserSettings(settings).then(() => { });
                        $('#newsFeedModal').modal('hide');
                    }.bind(this, this);
                    scope.$watch('selectedItem', (newValue, oldValue) => {
                        if (newValue === oldValue)
                            return;
                        for (const news of scope.feed) {
                            if (news.date === newValue) {
                                scope.current = news;
                                if (document.getElementById('newsFeedExternalContent') && $('#newsFeedModal').hasClass('in'))
                                    document.getElementById('newsFeedExternalContent').setAttribute('src', news.link);
                                break;
                            }
                        }
                    });
                    scope.openModal = function () {
                        $('#newsFeedModal').modal('show');
                        document.getElementById('newsFeedExternalContent').setAttribute('src', scope.current.link);
                    };
                };
            }
            showNewsFeed(scope) {
                var _a;
                if (this.loading.feed || this.loading.setting || this.ignoreNewsFeed || this.lastMessageId === scope.current.date)
                    return;
                $('#newsFeedModal').modal('show');
                document.getElementById('newsFeedExternalContent').setAttribute('src', (_a = scope.current) === null || _a === void 0 ? void 0 : _a.link);
            }
            uniqueDate(feed, date) {
                if (date.length === 0)
                    date = new Date().toString();
                for (const item of feed) {
                    if (item.date === date) {
                        date = date + "_";
                    }
                }
                return date;
            }
        };
        NewsFeedDirective = __decorate([
            QMC.Directive('QMC.Home', 'qmNewsFeed', ['$http', '$sce', 'UserService'])
        ], NewsFeedDirective);
        Home.NewsFeedDirective = NewsFeedDirective;
        ;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        let VersionDirective = class VersionDirective {
            constructor($location, userService) {
                this.$location = $location;
                this.userService = userService;
                this.restrict = 'E';
                this.templateUrl = './version';
                this.replace = true;
                this.scope = {
                    versionInfo: '@',
                };
                this.link = (scope) => {
                    this.getVersions(scope);
                };
            }
            getVersions(scope) {
                this.userService.getVersionInfo().then((data) => {
                    scope.versionInfo = data;
                    if (data.webClientVersion.substring(0, 3) != data.qmcServerVersion.substring(0, 3))
                        $('#versionErrorModal').modal('show');
                }).catch((data) => {
                    if (JSON.stringify(data).toLocaleLowerCase().indexOf("txtext") > 0 || data == 500) {
                        setTimeout(function () {
                            $('#serverErrorModal').modal('show');
                        }, 5000);
                    }
                });
            }
        };
        VersionDirective = __decorate([
            QMC.Directive('QMC.Home', 'qmVersion', ['$location', 'UserService'])
        ], VersionDirective);
        Home.VersionDirective = VersionDirective;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Home;
    (function (Home) {
        let ChangelogController = class ChangelogController {
            /**
             * QMC.Home.Changelog
             * @constructor
             * @param $location
             * @param $timeout
             * @param $qui
             */
            constructor($http, $location, $timeout, $qui, userService) {
                this.$http = $http;
                this.$location = $location;
                this.$timeout = $timeout;
                this.$qui = $qui;
                this.userService = userService;
                this.versions = [];
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $qui.bindEvents();
                });
                this.userService.getVersionInfo().then((data) => {
                    const splitted = data.webClientVersion.split('.');
                    console.log(data, splitted);
                    for (let base = splitted[0]; base >= 6; base--) {
                        for (let sub = splitted[1]; sub >= 0; sub--) {
                            this.versions.push({
                                base: base,
                                sub: sub,
                                url: 'https://service.daarwin.de/changelogs/changelog-myneva-daarwin-web-'
                                    + base + '-' + sub + '/',
                                newest: base === splitted[0] && sub === splitted[1],
                                loaded: false
                            });
                        }
                    }
                    for (let i = 3; i >= 0; i--) {
                        this.versions.push({
                            base: 5,
                            sub: i,
                            url: 'https://service.daarwin.de/changelogs/changelog-myneva-daarwin-web-'
                                + 5 + '-' + i + '/',
                            newest: false,
                            loaded: false
                        });
                    }
                    for (let i = 5; i >= 0; i--) {
                        this.versions.push({
                            base: 4,
                            sub: i,
                            url: 'https://service.daarwin.de/changelogs/changelog-myneva-daarwin-web-'
                                + 4 + '-' + i + '/',
                            newest: false,
                            loaded: false
                        });
                    }
                    for (let i = 14; i >= 2; i--) {
                        this.versions.push({
                            base: 3,
                            sub: i,
                            url: (i > 8
                                ? 'https://service.daarwin.de/changelogs/changelog-myneva-daarwin-web-'
                                : 'https://service.daarwin.de/changelogs/changelog-daarwin-web-')
                                + 3 + '-' + i + '/',
                            newest: false,
                            loaded: false
                        });
                    }
                    console.log(this.versions);
                });
            }
        };
        ChangelogController = __decorate([
            QMC.Controller('QMC.Home', 'ChangelogController'),
            QMC.Inject('$http', '$location', '$timeout', '$qui', 'UserService')
        ], ChangelogController);
        Home.ChangelogController = ChangelogController;
    })(Home = QMC.Home || (QMC.Home = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../maps/qmc.home.js.map
